var _window, _window$document, _Highcharts$AST, _Highcharts$AST2;
import React__default, { useLayoutEffect, useEffect, useRef, useState, useCallback, useMemo, createContext, useContext } from 'react';
import { E as ErrorBoundary, c as classnames, H as HighchartsReact, T as Table, C as Controller, u as useForm } from './vendor-e8bcba7c.js';
import { createUseStyles, useTheme } from 'react-jss';
import { defineMessages, t, T, FormattedNumber } from '@sm/intl';
import debounce from 'lodash.debounce';
import { Box } from '@wds/box';
import { withSpacing, clsx, visuallyHidden, uniqueId } from '@wds/utils';
import { Typography } from '@wds/typography';
import { Button } from '@wds/button';
import Highcharts, { numberFormat } from 'highcharts';
import wordCloudModule from 'highcharts/modules/wordcloud';
import merge from 'lodash.merge';
import { renderToString } from 'react-dom/server';
import { ProgressCircle } from '@wds/progress-circle';
import { IconCaretDown, IconHelpFilled, IconX, IconWarning, IconStarFilled, IconHappyFilled, IconHeartFilled, IconThumbsUpFilled, IconCaretUp } from '@wds/icons';
import { ProgressBar } from '@wds/progress-bar';
import { Menu } from '@wds/menu';
import { Tabs, Tab } from '@wds/tabs';
import { uniqueId as uniqueId$1, map, merge as merge$1, upperFirst, lowerCase } from 'lodash';
import { SelectMenu } from '@wds/select-menu';
import { Slider } from '@wds/slider';
import { Modal } from '@wds/modal';
import { InputGroup } from '@wds/input-group';
import { Input } from '@wds/input';
import { Popout } from '@wds/popout';
import { List } from '@wds/list';
import { Checkbox } from '@wds/checkbox';
import { ButtonGroup } from '@wds/button-group';
import { sanitizeString } from '@sm/utils';
import assert from 'assert';
import HighchartsAccessibility from 'highcharts/modules/accessibility';
import { Table as Table$1 } from '@wds/table';
import '@wds/tooltip';
import HighchartsMore from 'highcharts/highcharts-more';
import { Pagination } from '@wds/pagination';
import 'react-dom';
const useStyles$r = createUseStyles(theme => ({
  wdsIcons: ({
    color,
    size
  }) => {
    var _theme$palette, _theme$palette2, _theme$palette2$color;
    const fontSize = size ? {
      fontSize: theme.iconSize[size]
    } : {
      fontSize: 'inherit'
    };
    const chosenColor =
    // @ts-expect-error Fallback styles are acceptable
    ((_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : _theme$palette.text[color]) || ((_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : (_theme$palette2$color = _theme$palette2[color]) === null || _theme$palette2$color === void 0 ? void 0 : _theme$palette2$color.main) || 'currentColor';
    return {
      ...fontSize,
      width: '1em',
      height: '1em',
      display: 'inline-block',
      verticalAlign: 'middle',
      textAlign: 'center',
      fill: chosenColor
    };
  }
}));

// https://reactjs.org/docs/higher-order-components.html#convention-wrap-the-display-name-for-easy-debugging
const getDisplayName = Component => Component.displayName || Component.name || 'Component';
function withIcon(Component) {
  function WithIcon({
    color,
    title,
    size,
    ...rest
  }) {
    const classes = useStyles$r({
      color,
      size
    });
    return React__default.createElement("svg", {
      className: classes.wdsIcons,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "xMidYMid",
      "aria-label": title,
      role: title ? 'img' : 'presentation',
      ...rest
    }, React__default.createElement(Component, null));
  }
  WithIcon.displayName = `WithIcon(${getDisplayName(Component)})`;
  WithIcon.getOriginalComponent = () => Component;
  return WithIcon;
}
createUseStyles({
  svgContainer: {
    display: 'inline-block',
    width: '1em',
    height: '1em'
  }
});
function DocumentXIconPath() {
  return React__default.createElement("path", {
    d: "m5.94.005 8.012.012C14.53.018 15 .487 15 1.067V14.95c0 .58-.47 1.05-1.05 1.05H2.05C1.47 16 1 15.53 1 14.95V4.94L5.94.004zM7 1.505V4.95c0 .541-.41.987-.936 1.044L5.95 6H2.5v8.5h11V1.514L7 1.505zM6.557 7.53 8 8.973 9.443 7.53a.765.765 0 0 1 1.083 1.082l-1.444 1.443 1.444 1.444a.765.765 0 0 1-1.083 1.082L8 11.138 6.557 12.58A.765.765 0 1 1 5.474 11.5l1.444-1.444-1.444-1.443A.765.765 0 1 1 6.557 7.53zM5.5 2.563 3.561 4.5H5.5V2.562z"
  });
}
var IconDocumentX = withIcon(DocumentXIconPath);
const useStyles$q = createUseStyles(theme => {
  var _theme$questionBody;
  return {
    fallbackComponent: {
      fontFamily: ((_theme$questionBody = theme.questionBody) === null || _theme$questionBody === void 0 ? void 0 : _theme$questionBody.fontFamily) ?? {},
      color: theme.questionColor,
      border: `1px solid ${theme.questionColor}`,
      borderRadius: '5px',
      width: '100%',
      height: '100%',
      minHeight: '220px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '& svg': {
        fill: theme.questionColor
      }
    },
    errorMessage: {
      marginLeft: `8px` // equivalent to wrench theme.spacing[2]
    }
  };
});

const COPY$t = defineMessages({
  ERROR: {
    id: 'FallbackComponent.ERROR',
    defaultMessage: 'Error loading question',
    description: '[Type: label][Vis: high] - error message indicating a question could not be loaded'
  }
});
function FallbackComponent() {
  const {
    fallbackComponent,
    errorMessage
  } = useStyles$q();
  return React__default.createElement("div", {
    className: fallbackComponent
  }, React__default.createElement(IconDocumentX, null), React__default.createElement("p", {
    className: errorMessage
  }, t(COPY$t.ERROR)));
}
const withErrorBoundary = Component => {
  const displayName = Component.displayName || Component.name || 'Component';
  function ComponentWithErrorBoundary(props) {
    return React__default.createElement(ErrorBoundary, {
      FallbackComponent: FallbackComponent
    }, React__default.createElement(Component, {
      ...props
    }));
  }
  ComponentWithErrorBoundary.displayName = `withErrorBoundary(${displayName})`;
  return ComponentWithErrorBoundary;
};
var ACCESS_TYPE;
(function (ACCESS_TYPE) {
  ACCESS_TYPE["REQUEST"] = "REQUEST";
  ACCESS_TYPE["UPGRADE"] = "UPGRADE";
  ACCESS_TYPE["FULL"] = "FULL";
  ACCESS_TYPE["NONE"] = "NONE";
})(ACCESS_TYPE || (ACCESS_TYPE = {}));
var STATUS;
(function (STATUS) {
  STATUS["ERROR"] = "error";
  STATUS["SUCCESS"] = "success";
  STATUS["IN_PROGRESS"] = "inProgress";
})(STATUS || (STATUS = {}));
const useStyles$p = createUseStyles(theme => ({
  reset: {
    border: 'none'
  },
  border: {
    borderTop: theme.border.main
  }
}));
function Keyline({
  className,
  spacingClass,
  ...props
}) {
  const {
    reset,
    border
  } = useStyles$p();
  return React__default.createElement("hr", {
    className: classnames(reset, className, spacingClass, border),
    ...props
  });
}
var Keyline$1 = withSpacing(Keyline);
const useStyles$o = createUseStyles(theme => ({
  linkButton: {
    fontSize: ({
      size = 'sm'
    }) => size === 'sm' ? theme.type.fontSize.bodySm : theme.type.fontSize.body,
    border: 0,
    background: 'none',
    color: theme.palette.text.link,
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline'
    }
  }
}));
const isAnchor = props => !!(props !== null && props !== void 0 && props.href);
/** Link like-button - does not exist in WDS but in needed in Analyze */
function LinkButton({
  className,
  children,
  size,
  spacingClass,
  ...props
}) {
  const {
    linkButton
  } = useStyles$o({
    size
  });
  if (isAnchor(props)) {
    return React__default.createElement("a", {
      className: clsx(className, linkButton, spacingClass),
      ...props
    }, children);
  }
  const {
    type = 'button',
    ...buttonProps
  } = props;
  return React__default.createElement("button", {
    className: clsx(className, linkButton, spacingClass),
    // eslint-disable-next-line react/button-has-type
    type: type,
    ...buttonProps
  }, children);
}
var LinkButton$1 = withSpacing(LinkButton);
const COPY$s = defineMessages({
  SHOW_COUNT: {
    id: 'WordCount.SHOW_COUNT',
    defaultMessage: 'Showing {count} {countCheck, plural, one { word } other { words }}',
    description: '[Type: label][Vis: med] - message to show word count on the footer'
  },
  IN_PROGRESS: {
    id: 'WordCount.IN_PROGRESS',
    defaultMessage: 'Text Analysis in progress...',
    description: '[Type: label][Vis: med] - message showing in progress on the footer'
  },
  NO_IMPORTANT_WORDS_FOUND: {
    id: 'WordCount.NO_IMPORTANT_WORDS_FOUND',
    defaultMessage: 'No important words found.',
    description: '[Type: label][Vis: med] - message to show when there is no result in the footer'
  }
});
function WordCount({
  count,
  status
}) {
  if (status === 'error') {
    return null;
  }
  if (status === 'inProgress') {
    return React__default.createElement(Typography, {
      variant: "body",
      component: "span"
    }, React__default.createElement(T, {
      desc: COPY$s.IN_PROGRESS
    }));
  }
  return React__default.createElement(Typography, {
    variant: "body",
    color: "darkMuted",
    component: "span"
  }, !count ? t(COPY$s.NO_IMPORTANT_WORDS_FOUND) : t(COPY$s.SHOW_COUNT, {
    countCheck: count,
    count: React__default.createElement("strong", {
      key: "bold-count"
    }, count)
  }));
}
const useStyles$n = createUseStyles({
  hover: {
    // needs as rule-reference
    '&:hover': {
      textDecoration: 'underline'
    }
  }
});
const COPY$r = defineMessages({
  REQUEST: {
    id: 'RequestAccessButton.REQUEST',
    defaultMessage: `Request feature`,
    description: '[Type: Button][Vis: med] - Button to request access to wordcloud customization'
  },
  UPGRADE: {
    id: 'RequestAccessButton.UPGRADE',
    defaultMessage: `Upgrade`,
    description: '[Type: Button][Vis: med] - Button to upgrade package for basic user'
  }
});
function RequestAccessButton({
  accessType,
  redirectLink
}) {
  const color = accessType === ACCESS_TYPE.REQUEST ? 'secondary' : 'upgrade';
  const buttonText = accessType === ACCESS_TYPE.REQUEST ? t(COPY$r.REQUEST) : t(COPY$r.UPGRADE);
  return accessType !== ACCESS_TYPE.FULL ? React__default.createElement(Box, {
    ml: 2
  }, React__default.createElement(Button, {
    size: "sm",
    buttonType: "button",
    color: color,
    href: redirectLink,
    target: "_blank"
  }, buttonText)) : null;
}
const useStyles$m = createUseStyles(theme => ({
  upgradeBanner: {
    padding: theme.spacing[3],
    backgroundColor: theme.palette.background.accent,
    '&.upgrade': {
      backgroundColor: '#FEF6D9' // Not available in theme
    }
  },

  title: {
    fontSize: theme.type.fontSize.bodySm,
    fontWeight: theme.type.fontWeight.light,
    '& strong': {
      fontWeight: theme.type.fontWeight.medium,
      paddingRight: theme.spacing[1]
    }
  }
}));
const COPY$q = defineMessages({
  TITLE: {
    id: 'UpgradeBanner.TITLE',
    defaultMessage: 'Like what you see?',
    description: '[Type: Button][Vis: med] - Title displayed in bold text on upgrade banner'
  },
  SUBTITLE: {
    id: 'UpgradeBanner.SUBTITLE',
    defaultMessage: 'Upgrade to customize your own word cloud.',
    description: '[Type: Button][Vis: med] - Subtitle displayed in regular text on upgrade banner'
  }
});
function UpgradeBanner({
  accessType,
  redirectLink
}) {
  const {
    upgradeBanner,
    title
  } = useStyles$m();
  return React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
    className: `${upgradeBanner} ${accessType === ACCESS_TYPE.UPGRADE ? 'upgrade' : ''}`
  }, React__default.createElement(Box, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }, React__default.createElement("div", {
    className: title
  }, React__default.createElement("strong", null, React__default.createElement(T, {
    desc: COPY$q.TITLE
  })), React__default.createElement(T, {
    desc: COPY$q.SUBTITLE
  })), React__default.createElement(RequestAccessButton, {
    accessType: accessType,
    redirectLink: redirectLink
  }))), React__default.createElement(Keyline$1, null));
}
const COPY$p = defineMessages({
  COMBINED_WORDS: {
    id: 'WordCloudListFooter.COMBINED_WORDS',
    defaultMessage: 'Combined words',
    description: '[Type: label][Vis: med] - combined words as part of the word cloud list footer'
  },
  HIDDEN_WORDS: {
    id: 'WordCloudListFooter.HIDDEN_WORDS',
    defaultMessage: 'Hidden words',
    description: '[Type: label][Vis: med] - hidden words as part of the word cloud list footer'
  }
});
function WordCloudListFooter({
  accessType,
  redirectLink,
  wordCount,
  status,
  combinedWordsCount = 0,
  onCombineWordLinkClick,
  hiddenWordsCount,
  onHiddenWordsLinkClick
}) {
  const {
    hover
  } = useStyles$n();
  if (status === 'error') {
    return null;
  }
  return React__default.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    justifyContent: "stretch"
  }, accessType !== ACCESS_TYPE.FULL && React__default.createElement(UpgradeBanner, {
    accessType: accessType,
    redirectLink: redirectLink
  }), React__default.createElement(Box, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
    py: 4
  }, React__default.createElement(WordCount, {
    count: wordCount,
    status: status
  }), accessType === ACCESS_TYPE.FULL && status !== 'inProgress' && React__default.createElement(Box, {
    display: "flex",
    alignItems: "baseline",
    justifyContent: "flex-end"
  }, React__default.createElement(LinkButton$1, {
    onClick: () => onCombineWordLinkClick(undefined)
  }, React__default.createElement("span", {
    className: hover
  }, React__default.createElement(T, {
    desc: COPY$p.COMBINED_WORDS
  })), ' ', "(", combinedWordsCount, ")"), React__default.createElement(Box, {
    ml: 4,
    element: "span"
  }, React__default.createElement(LinkButton$1, {
    onClick: onHiddenWordsLinkClick
  }, React__default.createElement("span", {
    className: hover
  }, React__default.createElement(T, {
    desc: COPY$p.HIDDEN_WORDS
  }), " (", hiddenWordsCount, ")"))))));
}
const tooltipColor = '#333E48';
const COPY$o = defineMessages({
  TOOLTIP_TITLE: {
    id: 'WordCloudTooltip.TOOLTIP_TITLE',
    defaultMessage: '#{number} most important word',
    description: '[Type: header][Vis: med] - title of the chart'
  },
  OCCURRENCES: {
    id: 'WordCloudTooltip.TOOLTIP_OCCURRENCES',
    defaultMessage: 'Occurrences: {weight} ',
    description: '[Type: header][Vis: med] - title of the chart'
  }
});
// TODO: Port tooltip here to @wds/tooltip - not ported yet
function WordCloudTooltip({
  point
}) {
  return React__default.createElement("div", {
    "data-testid": `word-${point.name}`,
    style: {
      padding: '8px'
    }
  }, React__default.createElement(T, {
    desc: COPY$o.TOOLTIP_TITLE,
    values: {
      number: point.top
    }
  }), React__default.createElement("br", null), React__default.createElement("span", null, React__default.createElement(T, {
    desc: COPY$o.OCCURRENCES,
    values: {
      weight: point.weight,
      percentage: point.weight
    }
  }), "(", React__default.createElement(FormattedNumber, {
    formatStyle: "percent",
    maximumFractionDigits: 2,
    value: point.percentage
  }), ")"));
}
const tooltipConfig = {
  backgroundColor: tooltipColor,
  borderColor: tooltipColor,
  style: {
    color: 'white'
  },
  useHTML: true,
  formatter() {
    // Typescript bindings of highcharts binding of "this.point" missing
    /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
    // @ts-ignore
    const {
      point
    } = this;
    return renderToString(React__default.createElement(WordCloudTooltip, {
      point: point
    }));
  }
};
const BASE_OPTIONS = {
  title: {
    text: ''
  },
  credits: {
    enabled: false
  },
  chart: {
    backgroundColor: 'transparent'
  },
  plotOptions: {
    series: {
      dataLabels: {
        enabled: false
      }
    }
  }
};
const DEFAULT_COLOR = '#007FAA';
const getWeightBy = func => data => data.reduce((max, b) => func(max, b.weight), data[0].weight);
const colorizeModel = (data, colorPalette) => {
  const minOccurrence = getWeightBy(Math.min)(data);
  const maxOccurrence = getWeightBy(Math.max)(data);
  const spread = maxOccurrence - minOccurrence;
  const colorPaletteLength = colorPalette.length;
  const margin = Math.ceil(spread / colorPaletteLength);
  return data.map(w => {
    // Math.floor to keep the value less than the length of color palette
    const colorIndex = margin > 0 ? Math.floor((w.weight - minOccurrence) / margin) : 0;
    return {
      ...w,
      color: colorPalette[colorIndex >= colorPaletteLength ? colorPaletteLength - 1 : colorIndex]
    };
  });
};
const transformToHighChartsWordCloudModel = (words, total, fixedColor) => words.map((w, i) => ({
  name: w.word,
  weight: w.occurrences,
  percentage: w.percentage ? w.percentage : w.occurrences / total,
  // determine top word order
  top: words.length - i,
  color: fixedColor,
  custom: w.combinedWord ?? undefined
}));
const getWordCloudOptions = (data, options, fontFamily, handleClickEvent) => {
  return merge(
  // overwritable defaults
  {
    /**
     * Allows complete tooltip customization from exposed options.
     * i.e., If custom tooltip exists but doesn't have a formatter, default tooltip's formatter will always be in options.
     */
    tooltip: !options.tooltip ? tooltipConfig : {},
    series: [{
      style: {
        fontFamily: `${fontFamily}`,
        fontWeight: '400'
      },
      minFontSize: 12
    }]
  }, options,
  // not overwritable
  {
    ...BASE_OPTIONS,
    series: [{
      type: 'wordcloud',
      rotation: {
        from: 0,
        to: 0
      },
      data,
      events: {
        click: handleClickEvent
      }
    }]
  });
};
function LegendBlocks({
  range,
  width,
  scale,
  onFill
}) {
  const rangeMap = Array.from(new Array(range));
  return React__default.createElement(React__default.Fragment, null, rangeMap.map((a, i) => {
    const size = width + i * 2;
    const posX = i * Math.ceil((size + 10) / 2);
    const posY = (scale - size) / 2;
    return (/* eslint-disable-next-line react/no-array-index-key */
      React__default.createElement("g", {
        key: `part-${i}`
      }, React__default.createElement("rect", {
        width: size,
        height: size,
        x: posX,
        y: posY,
        rx: 3,
        style: {
          fill: onFill(i)
        }
      }))
    );
  }));
}
const useStyles$l = createUseStyles(theme => ({
  line: {
    stroke: theme.palette.border.hover,
    strokeWidth: 0.7
  },
  legendText: ({
    range
  }) => ({
    fontSize: `${range}px`,
    fill: theme.palette.border.hover
  })
}));
function LegendLabel({
  range,
  width,
  isStart,
  scale,
  text
}) {
  const styles = useStyles$l({
    range
  });
  const index = isStart ? 0 : range - 1;
  const size = width + index * 2;
  const posX = index * Math.ceil((size + 10) / 2);
  const posY = (scale - size) / 2;
  const textPosY = posY + size + (range + 6);
  return React__default.createElement("g", null, React__default.createElement("g", null, React__default.createElement("line", {
    className: styles.line,
    x1: posX + size / 2,
    y1: posY + size + 1,
    x2: posX + size / 2,
    y2: posY + size + 6
  })), React__default.createElement("g", null, React__default.createElement("text", {
    x: posX + size / 2,
    y: textPosY,
    textAnchor: "middle",
    className: styles.legendText
  }, text)));
}
const useWordCloudLegendStyles = createUseStyles(theme => ({
  legendContainer: ({
    maxWidth
  }) => ({
    border: `1px solid ${theme.palette.muted.main}`,
    paddingBottom: theme.spacing['5'],
    paddingLeft: theme.spacing['4'],
    paddingRight: theme.spacing['4'],
    paddingTop: theme.spacing['4'],
    maxWidth,
    width: '100%',
    height: '100%'
  }),
  legendWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  legendTitle: {
    textAlign: 'center',
    color: theme.palette.border.hover,
    fontSize: '11px',
    paddingBottom: theme.spacing['2']
  },
  legendLess: {
    flex: 0.2,
    alignSelf: 'center',
    textAlign: 'center',
    paddingLeft: theme.spacing['2'],
    paddingRight: theme.spacing['2'],
    color: theme.palette.border.hover,
    fontSize: '11px'
  },
  legendMore: {
    flex: 0.2,
    paddingLeft: theme.spacing['2'],
    paddingRight: theme.spacing['2'],
    color: theme.palette.border.hover,
    fontSize: '11px'
  },
  legend: {
    flex: 1
  },
  svg: {
    overflow: 'visible !important'
  }
}));
const baseSize$1 = 9;
const maxWidthFactor = 34;
const baseMaxWidth = 270;
const defaultLength = 8;
const COPY$n = defineMessages({
  TITLE: {
    id: 'WordCloudLegend.TITLE',
    defaultMessage: 'Number of mentions',
    description: '[Type: header][Vis: med] - title of the legend'
  },
  FEWER: {
    id: 'WordCloudLegend.FEWER',
    defaultMessage: 'fewer',
    description: '[Type: header][Vis: med] - fewer'
  },
  MORE: {
    id: 'WordCloudLegend.MORE',
    defaultMessage: 'more',
    description: '[Type: header][Vis: med] - more'
  }
});
function WordCloudLegend({
  fixedColor = '#000',
  colorPalette = [],
  min,
  max
}) {
  const range = colorPalette.length ? colorPalette.length : defaultLength;
  const scaleY = range * 4;
  const maxWidth = Math.max(baseMaxWidth, range * maxWidthFactor);
  const styles = useWordCloudLegendStyles({
    maxWidth
  });
  if (!Number.isInteger(min) || !Number.isInteger(max)) {
    return null;
  }
  return React__default.createElement("div", {
    className: styles.legendContainer
  }, React__default.createElement("div", {
    className: styles.legendTitle
  }, React__default.createElement(T, {
    desc: COPY$n.TITLE
  })), React__default.createElement("div", {
    className: styles.legendWrapper
  }, React__default.createElement("div", {
    className: styles.legendLess
  }, React__default.createElement(T, {
    desc: COPY$n.FEWER
  })), React__default.createElement("div", {
    className: styles.legend
  }, React__default.createElement("svg", {
    viewBox: `0 0 ${range * (range + 10)} ${scaleY}`,
    className: styles.svg,
    preserveAspectRatio: "xMidYMid"
  }, React__default.createElement(LegendBlocks, {
    range: range,
    width: baseSize$1,
    scale: scaleY,
    onFill: pos => !(colorPalette !== null && colorPalette !== void 0 && colorPalette.length) ? fixedColor : colorPalette[pos]
  }), React__default.createElement(LegendLabel, {
    range: range,
    width: baseSize$1,
    isStart: true,
    scale: scaleY,
    text: min
  }), React__default.createElement(LegendLabel, {
    range: range,
    width: baseSize$1,
    scale: scaleY,
    text: max
  }))), React__default.createElement("div", {
    className: styles.legendMore
  }, React__default.createElement(T, {
    desc: COPY$n.MORE
  }))));
}

// Sonar compliant
const sortWords = words => [...words].sort((a, b) => a.occurrences - b.occurrences);
function WordCloud({
  words = [],
  options = {},
  fixedColor = DEFAULT_COLOR,
  colorPalette,
  colorAssignFunction,
  showLegend,
  fontFamily = 'National 2',
  onWordClick
}) {
  if (!words.length) {
    return null;
  }
  const total = words.reduce((acc, {
    occurrences = 0
  }) => acc + occurrences, 0);
  let data = transformToHighChartsWordCloudModel(sortWords(words), total, fixedColor);
  const minOccurrence = getWeightBy(Math.min)(data);
  const maxOccurrence = getWeightBy(Math.max)(data);
  if (colorPalette) {
    const {
      palette
    } = colorPalette;
    data = colorAssignFunction ? colorAssignFunction(data, palette) : colorizeModel(data, palette);
  }
  const handleClickEvent = evt => {
    if (onWordClick) {
      onWordClick(evt);
    }
  };
  const wordCloudOptions = getWordCloudOptions(data, options, fontFamily, handleClickEvent);
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(HighchartsReact
  // this is needed for SSR rendering
  , {
    // this is needed for SSR rendering
    highcharts: typeof Highcharts === 'object' ? wordCloudModule(Highcharts) : Highcharts,
    options: wordCloudOptions
  }), showLegend && React__default.createElement(Box, {
    display: "flex",
    justifyContent: "center"
  }, React__default.createElement(WordCloudLegend, {
    colorPalette: colorPalette === null || colorPalette === void 0 ? void 0 : colorPalette.scales,
    fixedColor: fixedColor,
    min: minOccurrence,
    max: maxOccurrence
  })));
}
function WordCloudMainView({
  onWordClick,
  ...props
}) {
  if (!props.words) {
    return null;
  }
  const handleWordClick = evt => {
    const word = {
      word: evt.point.name,
      occurrences: evt.point.options.weight ?? 0,
      combinedWord: evt.point.options.custom
    };
    onWordClick(word);
  };
  return React__default.createElement(WordCloud, {
    ...props,
    onWordClick: handleWordClick
  });
}

/*eslint spaced-comment: ["error", "never", { "exceptions": ["NOSONAR"] }] */
/**
 * SSR Safe version of useLayoutEffect
 * @see https://code.corp.surveymonkey.com/webplatform/smweb/blob/master/apps/contentweb/src/app/pages/MRX/helpers/useIsomorphicLayoutEffect.js
 *
 * Note: `NOSONAR` is used to bypass a `minor:code-smell` error that states `createElement` is deprecated.
 * The eslint rule above disables the spaced comments to use NOSONAR as stated in the docs.
 */
const useSSRSafeLayoutEffect = typeof window !== 'undefined' && typeof ((_window = window) === null || _window === void 0 ? void 0 : (_window$document = _window.document) === null || _window$document === void 0 ? void 0 : _window$document.createElement) !== 'undefined' //NOSONAR
? useLayoutEffect : useEffect;
function useDimensions() {
  const target = useRef(null);
  const [dimensions, setDimensions] = useState({});
  useSSRSafeLayoutEffect(() => {
    const updateDimensions = () => {
      if (target.current) {
        const rect = {
          width: target.current.offsetWidth,
          height: target.current.offsetHeight
        };
        setDimensions(rect);
      }
    };
    window.addEventListener('resize', updateDimensions);
    updateDimensions();
    return () => window.removeEventListener('resize', updateDimensions);
  }, [target]);
  return [target, dimensions];
}
const COPY$m = defineMessages({
  LOADING: {
    id: 'LoadingState.LOADING',
    defaultMessage: 'Loading responses',
    description: '[Type: body][Vis: low] - indicated the view is loading'
  }
});
function LoadingState({
  size = 'md'
}) {
  return React__default.createElement(Box, {
    "data-testid": "progress-circle",
    display: "flex",
    justifyContent: "center",
    my: 3
  }, React__default.createElement(ProgressCircle, {
    size: size,
    continuous: true,
    valueText: t(COPY$m.LOADING)
  }));
}
const useStyles$k = createUseStyles({
  tableRow: {
    display: 'table'
  }
});
function VirtualizedTable({
  className = '',
  dimensions,
  disableHeader = true,
  hasNextPage,
  headerHeight = 0,
  rowHeight,
  rowItems
}) {
  const rowCount = hasNextPage ? rowItems.length + 1 : rowItems.length;
  const {
    tableRow
  } = useStyles$k();
  const isRowLoaded = ({
    index
  }) => !hasNextPage || index < rowItems.length;
  const rowRenderer = ({
    index,
    key,
    style
  }) => {
    const rowItem = !isRowLoaded({
      index
    }) ? React__default.createElement(LoadingState, {
      size: "sm"
    }) : rowItems[index];
    return React__default.createElement("div", {
      key: key,
      style: style,
      role: "row",
      className: tableRow
    }, rowItem);
  };
  const rowGetter = ({
    index
  }) => rowItems[index];
  if (!dimensions.width || !dimensions.height) {
    return null;
  }
  return React__default.createElement(Table, {
    className: className,
    headerHeight: headerHeight,
    rowHeight: rowHeight,
    rowCount: rowCount,
    overscanRowCount: 3,
    rowGetter: rowGetter,
    rowRenderer: rowRenderer,
    disableHeader: disableHeader,
    ...dimensions
  });
}
const useStyles$j = createUseStyles(theme => ({
  container: {
    height: 400,
    maxHeight: 400
  },
  table: {
    '& th': visuallyHidden,
    '& div[role="row"]': {
      borderBottom: theme.border.muted,
      '&:hover': {
        background: theme.palette.background.accent
      }
    },
    '& div[role="cell"]': {
      display: 'table-cell',
      padding: [theme.spacing[3], theme.spacing[2]],
      verticalAlign: 'middle'
    },
    '& div[role="cell"]:first-child': {
      width: '35%'
    },
    '& div[role="cell"]:nth-child(2)': {
      width: '35%'
    },
    '& div[role="cell"]:nth-child(3)': {
      width: '15%',
      paddingLeft: theme.spacing[5]
    },
    '& div[role="cell"]:nth-child(4)': {
      width: '15%',
      paddingLeft: theme.spacing[5]
    },
    '& strong': {
      fontWeight: theme.type.fontWeight.medium
    }
  },
  menuItem: {
    fontSize: theme.type.fontSize.bodySm,
    cursor: 'pointer'
  }
}));

/** `ActionMenu` should always be rendered inside of a `form` tag with submit handled */
function ActionMenu({
  onClose,
  onShow,
  show,
  renderTo,
  menuContent,
  menuTrigger,
  stretched,
  autoClose = true,
  placement = 'bottom-left'
}) {
  return React__default.createElement(Menu, {
    autoClose: autoClose,
    dense: true,
    renderTo: renderTo,
    onChange: isOpen => {
      if (isOpen) {
        if (onShow) {
          onShow();
        }
      } else if (onClose) {
        onClose();
      }
    },
    menuTrigger: menuTrigger,
    placement: placement,
    show: show,
    stretched: stretched
  }, menuContent);
}
const COPY$l = defineMessages({
  COMBINE_WITH: {
    id: 'WordCloudListViewMenuContent.COMBINE_WITH',
    defaultMessage: 'Combine with',
    description: '[Type: Button][Vis: high] - Combine with'
  },
  HIDE_FROM_WORD_CLOUD: {
    id: 'WordCloudListViewMenuContent.HIDE_FROM_WORD_CLOUD',
    defaultMessage: 'Hide from word cloud',
    description: '[Type: Button][Vis: high] - Hide from word cloud'
  },
  EDIT_COMBINED_WORDS: {
    id: 'WordCloudListViewMenuContent.EDIT_COMBINED_WORDS',
    defaultMessage: 'Edit combined words',
    description: '[Type: Button][Vis: low] - Edit combined words'
  },
  SPLIT_COMBINED_WORDS: {
    id: 'WordCloudListViewMenuContent.SPLIT_COMBINED_WORDS',
    defaultMessage: 'Split combined words',
    description: '[Type: Button][Vis: low] - Split combined words'
  },
  EXPAND_MENU_LABEL: {
    id: 'WordCloudListViewMenuContent.EXPAND_MENU_LABEL',
    defaultMessage: 'Expand menu',
    description: '[Type: label][Vis: low] - menu icon assistive text for screen readers'
  }
});
function WordCloudListViewMenuContent({
  word,
  onEditCombinedWords,
  onCombineWordLinkClick,
  onHideFromWordCloudLinkClick,
  onSplitCombinedWords,
  handleMenuClose
}) {
  const {
    menuItem
  } = useStyles$j();
  return React__default.createElement(React__default.Fragment, null, word.combinedWord && React__default.createElement(React__default.Fragment, null, React__default.createElement(Menu.Item, {
    onClick: () => onEditCombinedWords(word),
    handleMenuClose: handleMenuClose
  }, React__default.createElement("span", {
    className: menuItem
  }, React__default.createElement(T, {
    desc: COPY$l.EDIT_COMBINED_WORDS
  }))), React__default.createElement(Menu.Item, {
    onClick: () => onSplitCombinedWords(word),
    handleMenuClose: handleMenuClose
  }, React__default.createElement("span", {
    className: menuItem
  }, React__default.createElement(T, {
    desc: COPY$l.SPLIT_COMBINED_WORDS
  })))), !word.combinedWord && React__default.createElement(React__default.Fragment, null, React__default.createElement(Menu.Item, {
    onClick: () => onCombineWordLinkClick(word),
    handleMenuClose: handleMenuClose
  }, React__default.createElement("span", {
    className: menuItem
  }, React__default.createElement(T, {
    desc: COPY$l.COMBINE_WITH
  }), "...")), React__default.createElement(Menu.Item, {
    onClick: () => onHideFromWordCloudLinkClick(word.word),
    handleMenuClose: handleMenuClose
  }, React__default.createElement("span", {
    className: menuItem
  }, React__default.createElement(T, {
    desc: COPY$l.HIDE_FROM_WORD_CLOUD
  })))));
}
const COPY$k = defineMessages({
  EXPAND_MENU_LABEL: {
    id: 'WordCloudListRowItem.EXPAND_MENU_LABEL',
    defaultMessage: 'Expand menu',
    description: '[Type: label][Vis: low] - menu icon assistive text for screen readers'
  }
});
function WordCloudListRowItem({
  word,
  index,
  renderTo,
  percentage,
  onWordClick,
  ...wordCloudListViewMenuContentCallbacks
}) {
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  return React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
    role: "cell"
  }, React__default.createElement(ActionMenu, {
    show: menuIsOpen,
    renderTo: renderTo,
    onClose: () => setMenuIsOpen(false),
    onShow: () => setMenuIsOpen(true),
    placement: "bottom-left",
    menuTrigger: React__default.createElement(IconCaretDown, {
      "data-testid": `word-cloud-list-row-icon-${index}`,
      size: "sm",
      title: t(COPY$k.EXPAND_MENU_LABEL)
    }),
    menuContent: React__default.createElement(WordCloudListViewMenuContent, {
      word: word,
      handleMenuClose: () => setMenuIsOpen(false),
      ...wordCloudListViewMenuContentCallbacks
    })
  }), React__default.createElement(LinkButton$1, {
    ml: 3,
    onClick: () => {
      onWordClick(word);
    }
  }, word.word)), React__default.createElement("div", {
    role: "cell"
  }, React__default.createElement(ProgressBar, {
    percent: percentage,
    size: "lg",
    color: "secondary"
  })), React__default.createElement("div", {
    role: "cell"
  }, React__default.createElement(Typography, {
    variant: "bodySm"
  }, React__default.createElement("strong", null, percentage.toFixed(2), "%"))), React__default.createElement("div", {
    role: "cell"
  }, React__default.createElement(Typography, {
    variant: "bodySm"
  }, React__default.createElement("strong", null, word.occurrences))));
}
function renderRowItems({
  words,
  ...callbacks
}, renderTo) {
  return words.map((word, index) => {
    const percentage = word.percentage ? word.percentage * 100 : 0;
    return React__default.createElement(WordCloudListRowItem, {
      word: word,
      index: index,
      percentage: percentage,
      renderTo: renderTo || undefined,
      ...callbacks
    });
  });
}
function WordCloudListView({
  words = [],
  ...callbacks
}) {
  const {
    container,
    table
  } = useStyles$j();
  const [renderTo, setRenderTo] = useState(null);
  const handleRef = useCallback(instance => {
    if (!renderTo) {
      setRenderTo(instance);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [tableParentRef, {
    width,
    height
  }] = useDimensions();
  const rowItems = renderRowItems({
    words,
    ...callbacks
  }, renderTo);
  return React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
    ref: handleRef
  }), React__default.createElement("div", {
    ref: tableParentRef,
    role: "table",
    className: container
  }, React__default.createElement(VirtualizedTable, {
    rowHeight: 46,
    hasNextPage: false,
    rowItems: rowItems,
    dimensions: {
      width,
      height
    },
    className: table
  })));
}
function WordCloudViewSelector({
  currentView,
  words,
  colorPaletteOptions,
  selectedColorPaletteId,
  isMultiColorSelected,
  fontFamily,
  fixedColor,
  onWordClick,
  onCombineWordLinkClick,
  onHideFromWordCloudLinkClick,
  onEditCombinedWords,
  onSplitCombinedWords
}) {
  if (currentView === 'list') {
    return React__default.createElement(WordCloudListView, {
      words: words,
      onWordClick: onWordClick,
      onCombineWordLinkClick: onCombineWordLinkClick,
      onHideFromWordCloudLinkClick: onHideFromWordCloudLinkClick,
      onEditCombinedWords: onEditCombinedWords,
      onSplitCombinedWords: onSplitCombinedWords
    });
  }
  return React__default.createElement(WordCloudMainView, {
    colorPalette: isMultiColorSelected ? colorPaletteOptions[selectedColorPaletteId - 1] : undefined,
    fixedColor: !isMultiColorSelected ? fixedColor : undefined,
    showLegend: true,
    words: words,
    fontFamily: fontFamily,
    onWordClick: onWordClick
  });
}
const COPY$j = defineMessages({
  COLOR: {
    id: 'WordCloudCustomizationTabs.COLOR',
    defaultMessage: `COLOR`,
    description: '[Type: Button][Vis: med] - Button for tab to navigate to color'
  },
  FONT: {
    id: 'WordCloudCustomizationTabs.FONT',
    defaultMessage: `FONT`,
    description: '[Type: Button][Vis: med] - Button for tab to navigate to font'
  },
  RANGE: {
    id: 'WordCloudCustomizationTabs.RANGE',
    defaultMessage: `RANGE`,
    description: '[Type: Button][Vis: med] - Button for tab to navigate to range'
  }
});
function WordCloudCustomizationTabs({
  colorTab,
  fontTab,
  rangeTab
}) {
  const [selectedTab, setSelectedTab] = useState('color');
  const onTabChange = evt => {
    const value = evt.currentTarget.getAttribute('value');
    if (value) {
      setSelectedTab(value);
    }
  };
  return React__default.createElement(Tabs, {
    onChange: onTabChange,
    fullWidth: true
  }, React__default.createElement(Tab, {
    title: t(COPY$j.COLOR),
    value: "color",
    "data-testid": "wc-customization-color",
    selected: selectedTab === 'color'
  }, colorTab), React__default.createElement(Tab, {
    title: t(COPY$j.FONT),
    value: "font",
    "data-testid": "wc-customization-font",
    selected: selectedTab === 'font'
  }, fontTab), (rangeTab || null) && React__default.createElement(Tab, {
    title: t(COPY$j.RANGE),
    "data-testid": "wc-customization-range",
    value: "range",
    selected: selectedTab === 'range'
  }, rangeTab));
}
const useStyles$i = createUseStyles(theme => ({
  strong: {
    fontWeight: 500
  },
  colorSelectorWrapper: {
    width: 160,
    height: 96,
    border: theme.border.main,
    borderRadius: theme.spacing[1],
    backgroundColor: theme.palette.background.light,
    cursor: 'pointer',
    '&.selected': {
      borderColor: theme.palette.data.two
    },
    '&:hover:not(.selected)': {
      opacity: '0.6'
    }
  },
  colorSelector: {
    position: 'relative',
    width: 75,
    height: 36,
    padding: '2px',
    border: theme.border.main,
    '& ul': {
      margin: 0,
      padding: 0,
      display: 'flex',
      '& li': {
        listStyleType: 'none',
        height: 30,
        flexGrow: 1,
        flexBasis: 1
      }
    },
    '& .arrow': {
      position: 'absolute',
      bottom: 0,
      right: 0,
      display: 'flex',
      backgroundColor: theme.palette.background.light
    }
  },
  colorSwatches: {
    width: 200,
    padding: theme.spacing[1],
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& li': {
      padding: theme.spacing[1]
    }
  },
  colorSwatch: {
    boxSizing: 'border-box',
    border: theme.border.main,
    borderColor: theme.palette.transparent,
    '&:hover': {
      borderColor: theme.palette.border.main
    },
    '&.selected': {
      borderColor: theme.palette.data.two
    },
    '& div': {
      width: 18,
      height: 18,
      borderRadius: 1,
      marginRight: theme.spacing[1]
    }
  },
  colorPicker: {
    width: 0,
    height: 0,
    visibility: 'hidden',
    position: 'absolute',
    top: 0,
    left: 0
  }
}));
function ColorSelector({
  selected,
  menuTrigger,
  menuContent,
  toggleMultiColorSelector,
  title
}) {
  const {
    colorSelectorWrapper,
    strong,
    colorSelector
  } = useStyles$i();
  const [isOpen, setIsOpen] = useState(false);
  const toggleSelector = () => {
    setIsOpen(prevState => !prevState);
  };
  const handleSelectorClick = () => {
    if (!selected) {
      toggleMultiColorSelector();
    }
  };
  const handleKeyEvent = evt => {
    if (evt.key === 'Enter' && !selected) {
      toggleMultiColorSelector();
    }
  };
  return React__default.createElement("div", {
    className: `${colorSelectorWrapper} ${(selected || isOpen) && 'selected'}`,
    onClick: handleSelectorClick,
    onKeyPress: handleKeyEvent,
    role: "button",
    tabIndex: 0
  }, React__default.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }, React__default.createElement(Box, {
    pt: 2,
    pb: 2
  }, React__default.createElement(Typography, {
    variant: "bodySm",
    align: "center",
    className: strong
  }, title)), React__default.createElement(ActionMenu, {
    onClose: toggleSelector,
    onShow: toggleSelector,
    show: isOpen,
    placement: "bottom-left",
    menuTrigger: React__default.createElement("div", {
      className: colorSelector
    }, menuTrigger),
    menuContent: React__default.cloneElement(menuContent, {
      onCancelClick: toggleSelector
    })
  })));
}
function ColorSwatch({
  colorPalette,
  activeColorPaletteId,
  onSelectionChange
}) {
  const {
    groupId,
    palette
  } = colorPalette;
  const setActive = groupId === activeColorPaletteId;
  const {
    colorSwatch
  } = useStyles$i();
  return React__default.createElement("li", {
    key: `palette-${groupId}`
  }, React__default.createElement(Box, {
    p: 1,
    className: `${colorSwatch} ${setActive ? 'selected' : ''}`,
    display: "flex",
    onClick: () => onSelectionChange(groupId)
  }, palette.map(color => React__default.createElement("div", {
    key: uniqueId(`swatch-`),
    className: colorSwatch,
    style: {
      backgroundColor: color
    }
  }))));
}
const COPY$i = defineMessages({
  APPLY: {
    id: 'MultiColorSelectorMenu.APPLY',
    defaultMessage: `Apply`,
    description: '[Type: Button][Vis: med] - Button to Apply wordcloud color customization'
  },
  CANCEL: {
    id: 'MultiColorSelectorMenu.CANCEL',
    defaultMessage: `Cancel`,
    description: '[Type: Button][Vis: med] - Button to cancel wordcloud color customization'
  }
});
function MultiColorSelectorMenu({
  colorPaletteOptions,
  selectedColorPaletteId = 1,
  onCancelClick,
  onSaveMultiColorPaletteClick
}) {
  const {
    colorSwatches
  } = useStyles$i();
  const [activeColorPaletteId, setActiveColorPaletteId] = useState(selectedColorPaletteId);
  const onSelectionChange = selectGroupId => {
    setActiveColorPaletteId(selectGroupId);
  };
  const onSaveClick = () => {
    onSaveMultiColorPaletteClick(activeColorPaletteId);
    if (onCancelClick) {
      onCancelClick();
    }
  };
  return React__default.createElement("div", null, React__default.createElement("ul", {
    className: colorSwatches
  }, colorPaletteOptions === null || colorPaletteOptions === void 0 ? void 0 : colorPaletteOptions.map(colorPalette => React__default.createElement(ColorSwatch, {
    onSelectionChange: onSelectionChange,
    activeColorPaletteId: activeColorPaletteId,
    colorPalette: colorPalette
  }))), React__default.createElement(Box, {
    mb: 2,
    display: "flex",
    justifyContent: "center"
  }, React__default.createElement(Button, {
    size: "sm",
    buttonType: "button",
    color: "secondary",
    onClick: onCancelClick
  }, t(COPY$i.CANCEL)), React__default.createElement(Box, {
    ml: 2
  }, React__default.createElement(Button, {
    size: "sm",
    buttonType: "button",
    color: "primary",
    onClick: onSaveClick
  }, t(COPY$i.APPLY)))));
}
const OneColorSelectorMenu$1 = React__default.forwardRef(({
  fixedColor,
  onFixedColorChange
}, ref) => {
  const {
    colorPicker
  } = useStyles$i();
  const onChange = evt => {
    const {
      value
    } = evt.target;
    onFixedColorChange(value);
  };
  return React__default.createElement("input", {
    ref: ref,
    className: colorPicker,
    type: "color",
    tabIndex: -1,
    value: fixedColor,
    onInput: onChange
  });
});
function MultiColorSelectorTrigger({
  activeColorPalette,
  title
}) {
  return React__default.createElement(React__default.Fragment, null, React__default.createElement("ul", null, activeColorPalette === null || activeColorPalette === void 0 ? void 0 : activeColorPalette.palette.map(color => React__default.createElement("li", {
    key: `${uniqueId('color-palette-')}`,
    style: {
      backgroundColor: color
    }
  }))), React__default.createElement("div", {
    className: "arrow"
  }, React__default.createElement(IconCaretDown, {
    title: title,
    size: "sm"
  })));
}
function OneColorSelectorMenu({
  fixedColor,
  title,
  colorPickerRef
}) {
  useEffect(() => {
    colorPickerRef === null || colorPickerRef === void 0 ? void 0 : colorPickerRef.click();
  }, [colorPickerRef]);
  return React__default.createElement("div", {
    tabIndex: 0,
    role: "button"
  }, React__default.createElement("ul", null, React__default.createElement("li", {
    style: {
      backgroundColor: fixedColor
    }
  })), React__default.createElement("div", {
    className: "arrow"
  }, React__default.createElement(IconCaretDown, {
    title: title,
    size: "sm"
  })));
}
const useStyles$h = createUseStyles(theme => ({
  container: {
    backgroundColor: theme.palette.background.accent,
    padding: theme.spacing[4]
  },
  fontSelector: {
    width: 256
  },
  strong: {
    fontWeight: theme.type.fontWeight.medium
  },
  colorSelectorContainer: {
    borderRight: theme.border.main,
    width: 380,
    padding: theme.spacing[4],
    margin: -theme.spacing[4]
  },
  rangeSliderContainer: {
    paddingTop: theme.spacing[5],
    paddingBottom: theme.spacing[5]
  },
  rangeSlider: {
    width: 400
  },
  totalWordCount: {
    marginLeft: theme.spacing[5],
    marginRight: theme.spacing[1],
    paddingLeft: theme.spacing[1],
    paddingRight: theme.spacing[1],
    border: theme.border.main
  },
  footer: {
    backgroundColor: theme.palette.background.accent,
    padding: theme.spacing[3],
    '& label': {
      '& span': {
        fontSize: theme.type.fontSize.bodySm
      }
    }
  }
}));
const COPY$h = defineMessages({
  COLOR_SELECTOR_TITLE: {
    id: 'ColorTab.COLOR_SELECTOR_TITLE',
    defaultMessage: `How word clouds use color`,
    description: '[Type: Button][Vis: med] - Title for color selector tab'
  },
  COLOR_SELECTOR_DESCRIPTION: {
    id: 'ColorTab.COLOR_SELECTOR_DESCRIPTION',
    defaultMessage: `Multicolor word clouds use both color and size to indicate the number of times a word or phrase was mentioned.`,
    description: '[Type: Button][Vis: med] - Title for color selector tab'
  },
  MUTLI_COLOR_SELECTOR_LABEL: {
    id: 'ColorTab.MUTLI_COLOR_SELECTOR_LABEL',
    defaultMessage: `Multicolor`,
    description: '[Type: Button][Vis: med] - Label for multi color selector'
  },
  ONE_COLOR_SELECTOR_LABEL: {
    id: 'ColorTab.ONE_COLOR_SELECTOR_LABEL',
    defaultMessage: `One color`,
    description: '[Type: Button][Vis: med] - Label for multi color selector'
  },
  DOWN_ARROW: {
    id: 'ColorTab.DOWN_ARROW',
    defaultMessage: `Select dropdown arrow`,
    description: '[Type: Button][Vis: med] - Title for color selector dropdown'
  }
});
function ColorTab({
  colorPaletteOptions,
  selectedColorPaletteId,
  fixedColor,
  isMultiColorSelected,
  onSaveMultiColorPaletteClick,
  onFixedColorChange,
  toggleMultiColorSelector
}) {
  const {
    container,
    colorSelectorContainer,
    strong
  } = useStyles$h();
  const [colorPickerRef, setColorPickerRef] = useState(null);
  const handleRef = useCallback(instance => {
    if (!colorPickerRef) {
      setColorPickerRef(instance);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return React__default.createElement("div", {
    className: container
  }, React__default.createElement(Box, {
    display: "flex",
    pl: 4,
    pr: 4
  }, React__default.createElement("div", {
    className: colorSelectorContainer
  }, React__default.createElement(Box, {
    pl: 2,
    pr: 2,
    display: "flex"
  }, React__default.createElement(ColorSelector, {
    title: t(COPY$h.MUTLI_COLOR_SELECTOR_LABEL),
    selected: isMultiColorSelected,
    toggleMultiColorSelector: toggleMultiColorSelector,
    menuContent: React__default.createElement(MultiColorSelectorMenu, {
      selectedColorPaletteId: selectedColorPaletteId,
      colorPaletteOptions: colorPaletteOptions,
      onSaveMultiColorPaletteClick: onSaveMultiColorPaletteClick
    }),
    menuTrigger: React__default.createElement(MultiColorSelectorTrigger, {
      activeColorPalette: colorPaletteOptions[selectedColorPaletteId - 1],
      title: t(COPY$h.DOWN_ARROW)
    })
  }), React__default.createElement(Box, {
    ml: 2
  }, React__default.createElement(ColorSelector, {
    title: t(COPY$h.ONE_COLOR_SELECTOR_LABEL),
    menuTrigger: React__default.createElement(OneColorSelectorMenu, {
      fixedColor: fixedColor,
      title: t(COPY$h.DOWN_ARROW),
      colorPickerRef: colorPickerRef
    }),
    menuContent: React__default.createElement(OneColorSelectorMenu$1, {
      fixedColor: fixedColor,
      ref: handleRef,
      onFixedColorChange: onFixedColorChange
    }),
    selected: !isMultiColorSelected,
    toggleMultiColorSelector: toggleMultiColorSelector
  })))), React__default.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    pl: 6,
    pr: 6
  }, React__default.createElement(Typography, {
    variant: "bodySm"
  }, React__default.createElement("span", {
    className: strong
  }, t(COPY$h.COLOR_SELECTOR_TITLE))), React__default.createElement(Box, {
    mt: 3
  }, React__default.createElement(Typography, {
    variant: "bodySm"
  }, t(COPY$h.COLOR_SELECTOR_DESCRIPTION))))));
}
const FONT_MAP = [{
  label: 'Andale Mono',
  style: 'andale mono,monospace'
}, {
  label: 'Arial',
  style: 'arial,sans-serif'
}, {
  label: 'Arial Black',
  style: 'arial black,avant garde,sans-serif'
}, {
  label: 'Book Antiqua',
  style: 'book antiqua,palatino,serif'
}, {
  label: 'Comic Sans MS',
  style: 'comic sans ms,sans-serif'
}, {
  label: 'Courier New',
  style: 'courier new,courier,monospace'
}, {
  label: 'Droid Serif',
  style: 'droid serif,serif'
}, {
  label: 'Garamond',
  style: 'garamond,baskerville,serif'
}, {
  label: 'Georgia',
  style: 'georgia,palatino,serif'
}, {
  label: 'Helvetica',
  style: 'helvetica,helvetica neue,arial,sans-serif'
}, {
  label: 'Helvetica Neue',
  style: 'helvetica neue,helvetica,arial,sans-serif'
}, {
  label: 'Impact',
  style: 'impact,sans-serif'
}, {
  label: 'Lato',
  style: 'lato,sans-serif'
}, {
  label: 'Merriweather',
  style: 'merriweather,serif'
}, {
  label: 'Montserrat',
  style: 'montserrat,sans-serif'
}, {
  label: 'National 2',
  style: 'National2'
}, {
  label: 'Open Sans',
  style: 'open sans,sans-serif'
}, {
  label: 'Palatino',
  style: 'palatino,palatino linotype,serif'
}, {
  label: 'Roboto',
  style: 'roboto,sans-serif'
}, {
  label: 'Tahoma',
  style: 'tahoma,geneva,sans-serif'
}, {
  label: 'Terminal',
  style: 'terminal,monaco,monospace'
}, {
  label: 'Times New Roman',
  style: 'times new roman,times,serif'
}, {
  label: 'Trebuchet',
  style: 'trebuchet ms,geneva,sans-serif'
}, {
  label: 'Verdana',
  style: 'verdana,arial,sans-serif'
}, {
  label: 'Noto Sans (Traditional Chinese)',
  style: 'noto sans tc,sans-serif'
}, {
  label: 'Noto Sans (Japanese)',
  style: 'noto sans jp,sans-serif'
}, {
  label: 'Noto Sans (Korean)',
  style: 'noto sans kr,sans-serif'
}];
function FontTab({
  fontFamily,
  onFontChange
}) {
  const {
    container,
    fontSelector
  } = useStyles$h();
  return React__default.createElement("div", {
    className: container
  }, React__default.createElement("div", {
    className: fontSelector
  }, React__default.createElement(SelectMenu, {
    stretched: true,
    value: fontFamily,
    onChange: onFontChange
  }, FONT_MAP.map(font => React__default.createElement(SelectMenu.Option, {
    key: `${uniqueId$1('font-option-')}`,
    value: font.label
  }, font.label)))));
}
const COPY$g = defineMessages({
  RANGE_TAB_LABEL: {
    id: 'RangeTab.RANGE_TAB_LABEL',
    defaultMessage: `Mentions: {value}`,
    description: '[Type: Button][Vis: med] - Label for range slider in wordcloud customization'
  },
  TOTAL_WORDS: {
    id: 'RangeTab.TOTAL_WORDS',
    defaultMessage: `total words`,
    description: '[Type: Button][Vis: med] - Label for total word count display'
  }
});
function RangeTab({
  minRange,
  maxRange,
  minFrequency,
  wordCount,
  onSliderChange
}) {
  const {
    container,
    rangeSliderContainer,
    rangeSlider,
    totalWordCount
  } = useStyles$h();
  return React__default.createElement("div", {
    className: container
  }, React__default.createElement(Box, {
    className: rangeSliderContainer,
    display: "flex",
    alignItems: "flex-start"
  }, React__default.createElement(Box, {
    display: "flex"
  }, React__default.createElement("div", {
    className: rangeSlider
  }, React__default.createElement(Slider, {
    id: "range-slider",
    showTooltip: true,
    min: minRange,
    max: maxRange,
    controlled: true,
    values: [minFrequency < minRange ? minRange : minFrequency],
    onChange: onSliderChange
  }), React__default.createElement(Box, {
    display: "flex",
    justifyContent: "space-between"
  }, React__default.createElement(Typography, {
    variant: "bodySm"
  }, React__default.createElement(T, {
    desc: COPY$g.RANGE_TAB_LABEL,
    values: {
      value: minRange
    }
  })), React__default.createElement(Typography, {
    variant: "bodySm"
  }, React__default.createElement(T, {
    desc: COPY$g.RANGE_TAB_LABEL,
    values: {
      value: maxRange
    }
  }))))), React__default.createElement(Box, {
    display: "flex"
  }, React__default.createElement("div", {
    className: totalWordCount
  }, React__default.createElement(Typography, {
    variant: "bodySm"
  }, wordCount || '0')), React__default.createElement(Typography, {
    variant: "bodySm"
  }, React__default.createElement(T, {
    desc: COPY$g.TOTAL_WORDS
  })))));
}
function WordCloudCustomization({
  colorPaletteOptions,
  selectedColorPaletteId,
  fixedColor,
  fontFamily,
  footerComponent,
  isMultiColorSelected,
  minRange,
  maxRange,
  minFrequency,
  wordCount,
  isBasicUser,
  onFixedColorChange,
  onFontChange,
  onSliderChange,
  onSaveMultiColorPaletteClick,
  toggleMultiColorSelector
}) {
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(WordCloudCustomizationTabs, {
    colorTab: React__default.createElement(ColorTab, {
      colorPaletteOptions: colorPaletteOptions,
      selectedColorPaletteId: selectedColorPaletteId,
      fixedColor: fixedColor,
      isMultiColorSelected: isMultiColorSelected,
      onFixedColorChange: onFixedColorChange,
      onSaveMultiColorPaletteClick: onSaveMultiColorPaletteClick,
      toggleMultiColorSelector: toggleMultiColorSelector
    }),
    fontTab: React__default.createElement(FontTab, {
      fontFamily: fontFamily,
      onFontChange: onFontChange
    }),
    rangeTab: !isBasicUser && React__default.createElement(RangeTab, {
      minRange: minRange,
      maxRange: maxRange,
      minFrequency: minFrequency,
      wordCount: wordCount,
      onSliderChange: onSliderChange
    })
  }), footerComponent);
}
const COPY$f = defineMessages({
  CUSTOMIZE: {
    id: 'WordCloudCustomizationButton.CUSTOMIZE',
    defaultMessage: `Customize`,
    description: '[Type: Button][Vis: med] - Button to load customization options'
  }
});
function WordCloudCustomizationButton({
  setShowCustomization
}) {
  return React__default.createElement(Box, {
    mx: 6,
    mt: 4,
    mb: 4,
    display: "flex",
    justifyContent: "flex-end"
  }, React__default.createElement(Button, {
    variant: "solid",
    color: "muted",
    "data-testid": "customize-button",
    onClick: setShowCustomization,
    size: "sm"
  }, t(COPY$f.CUSTOMIZE)));
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useStyles$g = createUseStyles(theme => ({
  scrollY: ({
    height = 'auto',
    maxHeight = 'none',
    scrollable,
    flex
  }) => ({
    display: flex ? 'flex' : undefined,
    flexGrow: flex ? 1 : undefined,
    height: !Number.isNaN(height) && typeof height === 'number' ? `${height}px` : height,
    maxHeight: !Number.isNaN(maxHeight) && typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight,
    overflowY: scrollable ? 'auto' : 'hidden',
    '&::-webkit-scrollbar-thumb': {
      // This color is brand color 'stone' which is currently not in WrenchTheme
      backgroundColor: '#9DA5AA',
      borderRadius: '6px'
    },
    '&::-webkit-scrollbar': {
      backgroundColor: 'transparent',
      width: '6px',
      height: '6px'
    }
  })
}));
function ScrollableBox({
  children,
  height,
  maxHeight,
  scrollable,
  tabIndex,
  flex,
  ...props
}) {
  const {
    scrollY
  } = useStyles$g({
    height,
    maxHeight,
    scrollable,
    flex
  });
  const {
    className,
    spacingClass,
    ...rest
  } = props;
  const scrollableBoxTabIndex = () => {
    if (tabIndex) {
      return tabIndex;
    }
    return height ? 0 : undefined;
  };
  return React__default.createElement("div", {
    // Scrollable elements should be accessible by keyboard users
    tabIndex: scrollableBoxTabIndex(),
    className: classnames(className, spacingClass, scrollY),
    ...rest
  }, children);
}
var ScrollableBox$1 = withSpacing(ScrollableBox);
const COPY$e = defineMessages({
  HELP: {
    id: 'IconHelpStyled.HELP',
    defaultMessage: 'Help',
    description: '[Type: label][Vis: low] - text for aria label and icon'
  }
});
const useStyles$f = createUseStyles(theme => ({
  helpIcon: {
    cursor: 'help',
    '& [class^="wdsIcons"]:hover, & [class^="wdsIcons"]:focus': {
      fill: theme.palette.text.lightMuted
    }
  }
}));
/** Wrench `IconHelp` with help cursor and hover effect */
function IconHelpStyled({
  className
}) {
  const {
    helpIcon
  } = useStyles$f();
  return React__default.createElement("span", {
    className: clsx(helpIcon, className)
  }, React__default.createElement(IconHelpFilled, {
    color: "darkMuted",
    tabIndex: 0,
    title: t(COPY$e.HELP)
  }));
}
IconHelpStyled.displayName = 'HelpStyled'; // hack to work around Wrench Popup's 'trigger' proptype accessibility error (searches for Icon)

const useStyles$e = createUseStyles(theme => ({
  header: {
    fontWeight: theme.type.fontWeight.medium
  }
}));
function HelpPopout({
  popoutHeader,
  popoutContent
}) {
  const {
    header
  } = useStyles$e();
  const [renderTo, setRenderTo] = useState(null);
  const handleRef = useCallback(instance => {
    if (!renderTo) {
      setRenderTo(instance);
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);
  return React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
    ref: handleRef
  }), React__default.createElement(Popout, {
    autoFlip: true,
    delay: true,
    renderTo: renderTo || undefined,
    placement: "right",
    size: "sm",
    trigger: React__default.createElement(IconHelpStyled, null)
  }, React__default.createElement(Popout.Header, null, React__default.createElement(Typography, {
    component: "span"
  }, React__default.createElement("span", {
    className: header
  }, popoutHeader))), React__default.createElement(Popout.Body, null, React__default.createElement(Typography, {
    variant: "bodySm"
  }, popoutContent))));
}
const useStyles$d = createUseStyles(theme => ({
  wordCloudContainer: {
    position: 'relative'
  },
  wordCloudBlur: {
    filter: 'blur(2px)'
  },
  helpPopout: {
    marginLeft: 'auto',
    padding: theme.spacing[6]
  },
  editWordsModalBody: {
    background: theme.palette.background.main
  },
  wordListSection: {
    '& li': {
      width: '50%',
      borderBottom: 'none',
      '& div': {
        background: 'none'
      }
    }
  },
  sectionLabel: {
    fontWeight: theme.type.fontWeight.medium,
    fontSize: theme.type.fontSize.body
  }
}));
const filterHiddenWords = (wordCloudItems, hiddenWords) => {
  if (!hiddenWords.length) {
    return wordCloudItems;
  }
  return wordCloudItems.filter(({
    word
  }) => {
    const indexInHiddenWords = hiddenWords.findIndex(hiddenWord => hiddenWord.toLowerCase() === word.toLowerCase());
    return indexInHiddenWords === -1;
  });
};
const combineWords = (wordCloudItems, combinedWordCloudItems) => {
  if (!combinedWordCloudItems.length) {
    return wordCloudItems;
  }
  let filteredWordCloudItems = [...wordCloudItems];
  combinedWordCloudItems.forEach(combinedWordCloudItem => {
    const {
      title,
      words: combinedWords
    } = combinedWordCloudItem;
    // create new word
    const newWordCloudItem = {
      word: title,
      occurrences: 0,
      combinedWord: combinedWordCloudItem
    };
    // Remove words from original list
    combinedWords.forEach(combinedWordItem => {
      filteredWordCloudItems = filteredWordCloudItems.filter(filteredWordCloudItem => {
        const {
          word,
          occurrences
        } = filteredWordCloudItem;
        if (word.toLowerCase() === combinedWordItem.toLowerCase()) {
          newWordCloudItem.occurrences += occurrences;
          return false;
        }
        return true;
      });
    });
    // Add new combined word to the list
    filteredWordCloudItems.push(newWordCloudItem);
  });
  return filteredWordCloudItems.sort((a, b) => b.occurrences - a.occurrences);
};
const filterWordsByFrequency = (wordCloudItems, minFrequency) => {
  return wordCloudItems.filter(({
    occurrences
  }) => {
    return occurrences >= minFrequency && occurrences;
  });
};
const formatWords = (wordCloudItems, hiddenWords, combinedWords) => {
  if (!wordCloudItems.length) {
    return wordCloudItems;
  }
  // filter hidden words
  let filteredWordCloudItems = filterHiddenWords(wordCloudItems, hiddenWords);
  // calculate total word occurences
  const totalWords = wordCloudItems.reduce((partialSum, a) => partialSum + a.occurrences, 0);
  // replace all combined words with a new one
  filteredWordCloudItems = combineWords(filteredWordCloudItems, combinedWords);
  // Update percentages
  filteredWordCloudItems = filteredWordCloudItems.map(wordCloudItem => {
    return {
      ...wordCloudItem,
      percentage: wordCloudItem.occurrences / totalWords
    };
  });
  return filteredWordCloudItems;
};
const getMinAndMaxRange = wordCloudItems => {
  let minRange = Number.MAX_SAFE_INTEGER;
  let maxRange = 0;
  wordCloudItems.forEach(({
    occurrences
  }) => {
    minRange = Math.min(occurrences, minRange);
    maxRange = Math.max(occurrences, maxRange);
  });
  minRange = minRange >= maxRange ? maxRange - 1 : minRange;
  return [minRange, maxRange];
};
const getFontStyle = fontFamily => {
  var _FONT_MAP$find;
  return (_FONT_MAP$find = FONT_MAP.find(({
    label
  }) => label === fontFamily)) === null || _FONT_MAP$find === void 0 ? void 0 : _FONT_MAP$find.style;
};
const getSelectedWordsForCustomization = formData => {
  const {
    words
  } = formData;
  return Object.entries(words).reduce((selectedWords, wordItem) => {
    if (wordItem[1]) {
      selectedWords.push(wordItem[0]);
    }
    return selectedWords;
  }, []);
};
const getInitialStateOfCustomizeWordsModal = (words, selectedWords) => {
  const initialSelectedState = {};
  words.forEach(({
    word
  }) => {
    initialSelectedState[word] = selectedWords ? selectedWords.indexOf(word) !== -1 : false;
  });
  return initialSelectedState;
};

/** Referentially stable empty function
 *
 * e.g. as default or placeholder */
// eslint-disable-next-line @typescript-eslint/no-empty-function
const EmptyFn = () => {};
const toKebabCase = text => text.toLowerCase().replace(/\s/g, '-');
const useStyles$c = createUseStyles(theme => ({
  footer: {
    backgroundColor: theme.palette.background.accent,
    padding: theme.spacing[3],
    '& label': {
      '& span': {
        fontSize: theme.type.fontSize.bodySm
      }
    }
  },
  wordListLabel: {
    whiteSpace: 'normal',
    '& *': {
      cursor: 'pointer'
    }
  }
}));
const WordListItem = React__default.forwardRef(({
  name,
  value,
  onChange,
  wordItem
}, ref) => {
  const {
    wordListLabel
  } = useStyles$c();
  const checkboxId = useMemo(() => uniqueId(`${toKebabCase(wordItem.word)}`), [wordItem]);
  return React__default.createElement(List.Item, {
    onClick: () => {
      onChange(!value);
    },
    interactive: true,
    addOnLeft: React__default.createElement(Checkbox, {
      checked: value,
      id: checkboxId,
      name: name,
      innerRef: ref,
      value: wordItem.word,
      ariaLabel: wordItem.word
    })
  }, React__default.createElement("label", {
    htmlFor: checkboxId,
    className: wordListLabel,
    onClick: e => e.preventDefault()
  }, React__default.createElement(Typography, {
    variant: "bodySm"
  }, wordItem.word)));
});
function WordList({
  control,
  words,
  validate
}) {
  return (
    // https://github.com/yannickcr/eslint-plugin-react/issues/2584
    // eslint-disable-next-line react/jsx-no-useless-fragment
    React__default.createElement(React__default.Fragment, null, words === null || words === void 0 ? void 0 : words.map(wordItem => !(wordItem !== null && wordItem !== void 0 && wordItem.combinedWord) && React__default.createElement(Controller, {
      key: wordItem.word,
      control: control,
      name: `words.${wordItem.word}`,
      rules: {
        validate
      },
      render: ({
        field: {
          ...props
        }
      }) => React__default.createElement(WordListItem, {
        wordItem: wordItem,
        ...props
      })
    })))
  );
}
const COPY$d = defineMessages({
  COMBINE_WORDS_HEADER: {
    id: 'CombineWordsModal.COMBINE_WORDS_HEADER',
    defaultMessage: 'Combine words',
    description: '[Type: label][Vis: high] - combine words modal header'
  },
  COMBINE_WORDS_EDIT_HEADER: {
    id: 'CombineWordsModal.COMBINE_WORDS_EDIT_HEADER',
    defaultMessage: 'Edit combined words',
    description: '[Type: label][Vis: high] - edit combine words modal header'
  },
  COMBINE_WORDS_HELP_TEXT: {
    id: 'CombineWordsModal.COMBINE_WORDS_HELP_TEXT',
    defaultMessage: 'Create a new word that replaces one or more selected words. You can edit this later to get your original words back.',
    description: '[Type: label][Vis: high] - combine words help text'
  },
  COMBINE_WORDS_INPUT_LABEL: {
    id: 'CombineWordsModal.COMBINED_WORDS_INPUT_LABEL',
    defaultMessage: '1. Create a new word',
    description: '[Type: label][Vis: high] - label for the new combined word input'
  },
  COMBINE_WORDS_INPUT_LABEL_PLACEHOLDER: {
    id: 'CombineWordsModal.COMBINE_WORDS_INPUT_LABEL_PLACEHOLDER',
    defaultMessage: 'Type any new word',
    description: '[Type: label][Vis: high] - placeholder for the input label'
  },
  COMBINE_WORDS_INPUT_LABEL_HELPER_TEXT: {
    id: 'CombineWordsModal.COMBINED_WORDS_INPUT_LABEL_HELPER_TEXT',
    defaultMessage: 'The new word replaces each of the selected words below.',
    description: '[Type: label][Vis: high] - helper text for the input label for the new combined word'
  },
  WORD_LIST_HEADER: {
    id: 'CombineWordsModal.WORD_LIST_HEADER',
    defaultMessage: '2. Choose words to combine',
    description: '[Type: label][Vis: high] - header for list of words section'
  },
  CANCEL_BUTTON_LABEL: {
    id: 'CombineWordsModal.CANCEL_BUTTON_LABEL',
    defaultMessage: 'Cancel',
    description: '[Type: label][Vis: high] - cancel button to dismiss the modal'
  },
  COMBINE_BUTTON_LABEL: {
    id: 'CombineWordsModal.SAVE_BUTTON_LABEL',
    defaultMessage: 'Combine',
    description: '[Type: label][Vis: high] - save button to combine words from word cloud'
  }
});
function CombineWordsModal({
  words,
  triggerWord,
  showModal,
  onClose,
  onCombine
}) {
  const wordListWords = useMemo(() => {
    let combinedWords = [...words];
    if (triggerWord !== null && triggerWord !== void 0 && triggerWord.combinedWord) {
      var _triggerWord$combined;
      combinedWords = [...((triggerWord === null || triggerWord === void 0 ? void 0 : (_triggerWord$combined = triggerWord.combinedWord) === null || _triggerWord$combined === void 0 ? void 0 : _triggerWord$combined.words.map(word => ({
        occurrences: 0,
        word
      }))) || [])].concat(combinedWords);
    }
    return combinedWords;
  }, [words, triggerWord]);
  const initialSelection = useMemo(() => {
    var _triggerWord$combined2, _triggerWord$combined3;
    const selectedWords = triggerWord !== null && triggerWord !== void 0 && triggerWord.combinedWord ? (_triggerWord$combined2 = triggerWord.combinedWord) === null || _triggerWord$combined2 === void 0 ? void 0 : _triggerWord$combined2.words : [(triggerWord === null || triggerWord === void 0 ? void 0 : triggerWord.word) ?? ''];
    const title = (triggerWord === null || triggerWord === void 0 ? void 0 : (_triggerWord$combined3 = triggerWord.combinedWord) === null || _triggerWord$combined3 === void 0 ? void 0 : _triggerWord$combined3.title) ?? '';
    return {
      words: getInitialStateOfCustomizeWordsModal(wordListWords, selectedWords),
      title
    };
  }, [wordListWords, triggerWord]);
  const {
    control,
    handleSubmit,
    getValues,
    reset,
    formState: {
      isDirty,
      isValid
    }
  } = useForm({
    defaultValues: initialSelection,
    mode: 'onChange'
  });
  const {
    sectionLabel,
    wordListSection,
    editWordsModalBody,
    helpPopout
  } = useStyles$d();
  const handleSave = formData => {
    /* TODO: fix after callback integration */
    onCombine(formData);
    onClose();
  };
  const validateCheckboxes = useCallback(() => {
    const selectedWords = getSelectedWordsForCustomization({
      words: getValues('words') ?? {}
    });
    return selectedWords.length > 1;
  }, [getValues]);
  useEffect(() => {
    reset(initialSelection);
  }, [initialSelection, reset, triggerWord]);
  if (!showModal) {
    return null;
  }
  return React__default.createElement(Modal, {
    "data-testid": "combine-words-modal",
    size: "md",
    show: true,
    dismissible: false
  }, React__default.createElement("form", {
    onSubmit: handleSubmit(handleSave)
  }, React__default.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    flexWrap: true
  }, React__default.createElement(Modal.Header, {
    header: t(triggerWord !== null && triggerWord !== void 0 && triggerWord.combinedWord ? COPY$d.COMBINE_WORDS_EDIT_HEADER : COPY$d.COMBINE_WORDS_HEADER)
  }), React__default.createElement("span", {
    className: helpPopout
  }, React__default.createElement(HelpPopout, {
    popoutHeader: t(COPY$d.COMBINE_WORDS_HEADER),
    popoutContent: t(COPY$d.COMBINE_WORDS_HELP_TEXT)
  }))), React__default.createElement(Modal.Body, {
    className: editWordsModalBody
  }, React__default.createElement(ScrollableBox$1, {
    height: 400,
    maxHeight: 400,
    scrollable: true
  }, React__default.createElement(Box, {
    "data-testid": "combine-word-input-group",
    mb: 5
  }, React__default.createElement(Typography, {
    variant: "body"
  }, React__default.createElement("span", {
    className: sectionLabel
  }, React__default.createElement(T, {
    desc: COPY$d.COMBINE_WORDS_INPUT_LABEL
  }))), React__default.createElement(Box, {
    pt: 2,
    pb: 2
  }, React__default.createElement(InputGroup, null, React__default.createElement(Controller, {
    control: control,
    name: "title",
    render: ({
      field: {
        onChange,
        value
      }
    }) => React__default.createElement(Input, {
      size: "sm",
      id: "combinedWordLabel",
      placeholder: t(COPY$d.COMBINE_WORDS_INPUT_LABEL_PLACEHOLDER),
      ariaLabel: t(COPY$d.COMBINE_WORDS_INPUT_LABEL),
      "data-testid": "new-label",
      onChange: onChange,
      value: value
    }),
    rules: {
      required: true
    }
  }))), React__default.createElement(Box, null, React__default.createElement(Typography, {
    variant: "bodySm",
    color: "secondary"
  }, React__default.createElement(T, {
    desc: COPY$d.COMBINE_WORDS_INPUT_LABEL_HELPER_TEXT
  })))), React__default.createElement(Box, null, React__default.createElement(Typography, null, React__default.createElement("span", {
    className: sectionLabel
  }, React__default.createElement(T, {
    desc: COPY$d.WORD_LIST_HEADER
  }))), React__default.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    flexWrap: true,
    className: wordListSection,
    "data-testid": "word-list"
  }, React__default.createElement(WordList, {
    control: control,
    words: wordListWords,
    validate: validateCheckboxes
  }))))), React__default.createElement(Modal.Footer, {
    align: "right"
  }, React__default.createElement(Button, {
    "data-testid": "cancel-combine-btn",
    size: "md",
    color: "secondary",
    variant: "ghost",
    onClick: onClose
  }, React__default.createElement(T, {
    desc: COPY$d.CANCEL_BUTTON_LABEL
  })), React__default.createElement(Button, {
    "data-testid": "combine-btn",
    size: "md",
    color: "primary",
    disabled: !isValid || !isDirty,
    onClick: handleSubmit(handleSave)
  }, React__default.createElement(T, {
    desc: COPY$d.COMBINE_BUTTON_LABEL
  })))));
}
const COPY$c = defineMessages({
  HIDE_WORDS_HEADER: {
    id: 'HideWordsModal.HIDE_WORDS_HEADER',
    defaultMessage: 'Hide words',
    description: '[Type: label][Vis: high] - hide words modal header'
  },
  HIDE_WORDS_HELP_TEXT: {
    id: 'HideWordsModal.HIDE_WORDS_HELP_TEXT',
    defaultMessage: 'Select words to hide them from the word cloud.',
    description: '[Type: label][Vis: high] - hide words help text'
  },
  HIDE_WORDS_LIST_LABEL: {
    id: 'HideWordsModal.HIDE_WORDS_LIST_LABEL',
    defaultMessage: 'Select words to hide',
    description: '[Type: label][Vis: high] - label for hide words checkboxes'
  },
  CANCEL_BUTTON_LABEL: {
    id: 'HideWordsModal.CANCEL_BUTTON_LABEL',
    defaultMessage: 'Cancel',
    description: '[Type: label][Vis: high] - cancel button to dismiss the modal'
  },
  HIDE_BUTTON_LABEL: {
    id: 'HideWordsModal.HIDE_BUTTON_LABEL',
    defaultMessage: 'Hide',
    description: '[Type: label][Vis: high] - save button to hide words from word cloud'
  },
  HIDE_BUTTON_LABEL_ON_EDIT: {
    id: 'HideWordsModal.HIDE_BUTTON_LABEL_ON_EDIT',
    defaultMessage: 'Save',
    description: '[Type: label][Vis: high] - save button to hide words from word cloud'
  }
});
function HideWordsModal({
  words,
  showModal,
  hiddenWords,
  handleClose,
  handleUpdateHiddenWords
}) {
  const {
    wordListSection,
    editWordsModalBody,
    helpPopout
  } = useStyles$d();
  const {
    control,
    handleSubmit,
    reset,
    formState: {
      isDirty
    }
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      words: getInitialStateOfCustomizeWordsModal(words, hiddenWords)
    }
  });
  useEffect(() => {
    reset({
      words: getInitialStateOfCustomizeWordsModal(words, hiddenWords)
    });
  }, [words, hiddenWords, reset]);
  const onSubmit = formData => {
    handleClose();
    handleUpdateHiddenWords(formData);
  };
  return React__default.createElement(Modal, {
    "data-testid": "hide-words-modal",
    size: "md",
    show: showModal,
    dismissible: false
  }, React__default.createElement(Box, {
    display: "flex",
    justifyContent: "space-between",
    "data-testid": "hide-word-help-popout"
  }, React__default.createElement(Modal.Header, {
    header: t(COPY$c.HIDE_WORDS_HEADER)
  }), React__default.createElement("span", {
    className: helpPopout
  }, React__default.createElement(HelpPopout, {
    popoutHeader: t(COPY$c.HIDE_WORDS_HEADER),
    popoutContent: t(COPY$c.HIDE_WORDS_HELP_TEXT)
  }))), React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, React__default.createElement(Modal.Body, {
    className: editWordsModalBody
  }, React__default.createElement(ScrollableBox$1, {
    scrollable: true,
    height: 400,
    maxHeight: 400
  }, React__default.createElement(Typography, {
    variant: "body"
  }, React__default.createElement(T, {
    desc: COPY$c.HIDE_WORDS_LIST_LABEL
  })), React__default.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    flexWrap: true,
    className: wordListSection
  }, React__default.createElement(WordList, {
    control: control,
    words: words
  })))), React__default.createElement(Modal.Footer, {
    align: "right"
  }, React__default.createElement(Button, {
    "data-testid": "cancel-hide-btn",
    size: "md",
    color: "secondary",
    variant: "ghost",
    onClick: handleClose
  }, React__default.createElement(T, {
    desc: COPY$c.CANCEL_BUTTON_LABEL
  })), React__default.createElement(Button, {
    disabled: !isDirty,
    buttonType: "submit",
    size: "md",
    color: "primary"
  }, hiddenWords.length > 0 ? React__default.createElement(T, {
    desc: COPY$c.HIDE_BUTTON_LABEL_ON_EDIT
  }) : React__default.createElement(T, {
    desc: COPY$c.HIDE_BUTTON_LABEL
  })))));
}
const AccessLevelByComponentContext = createContext({
  show: () => true,
  hide: () => false,
  disable: () => false,
  getAccessLevel: () => 'show'
});
const COPY$b = defineMessages({
  CHECKBOX_LABEL: {
    id: 'WordCloudCustomizationFooter.CHECKBOX_LABEL',
    defaultMessage: `Apply to all word clouds in the survey (Some may not change)`,
    description: '[Type: Button][Vis: med] - Label to apply customization to all word clouds'
  },
  APPLY: {
    id: 'WordCloudCustomizationFooter.APPLY',
    defaultMessage: `Apply`,
    description: '[Type: Button][Vis: med] - Button to apply wordcloud customization'
  },
  CANCEL: {
    id: 'WordCloudCustomizationFooter.CANCEL',
    defaultMessage: `Cancel`,
    description: '[Type: Button][Vis: med] - Button to cancel wordcloud customization'
  },
  NO_THANKS: {
    id: 'WordCloudCustomizationFooter.NO_THANKS',
    defaultMessage: `No thanks`,
    description: '[Type: Button][Vis: med] - Button to close wordcloud customization for users with limited access'
  },
  REQUEST: {
    id: 'WordCloudCustomizationFooter.REQUEST',
    defaultMessage: `Request feature`,
    description: '[Type: Button][Vis: med] - Button to request access to wordcloud customization'
  },
  UPGRADE: {
    id: 'WordCloudCustomizationFooter.UPGRADE',
    defaultMessage: `Upgrade`,
    description: '[Type: Button][Vis: med] - Button to upgrade package for basic user'
  }
});
function WordCloudListCustomizationFooter({
  onSaveClick,
  onCancelClick,
  redirectLink
}) {
  const {
    footer
  } = useStyles$c();
  const {
    show
  } = useContext(AccessLevelByComponentContext);
  const handleSaveButtonClick = () => {
    onSaveClick(false);
  };
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Keyline$1, null), React__default.createElement("div", {
    className: footer
  }, React__default.createElement(Box, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }, React__default.createElement(Typography, {
    variant: "bodySm"
  }, React__default.createElement(Box, {
    display: "flex"
  })), React__default.createElement(Box, {
    display: "flex"
  }, React__default.createElement(Button, {
    size: "sm",
    buttonType: "button",
    color: "secondary",
    onClick: onCancelClick
  }, t(show('wordcloud_customization') ? COPY$b.CANCEL : COPY$b.NO_THANKS)), show('wordcloud_customization') ? React__default.createElement(Box, {
    ml: 2
  }, React__default.createElement(Button, {
    size: "sm",
    buttonType: "button",
    color: "primary",
    onClick: handleSaveButtonClick
  }, t(COPY$b.APPLY))) : React__default.createElement(RequestAccessButton, {
    accessType: ACCESS_TYPE.UPGRADE,
    redirectLink: redirectLink
  })))), React__default.createElement(Keyline$1, null));
}
const useStyles$b = createUseStyles(theme => ({
  overlayContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: theme.elevation.sky
  },
  overlayCta: {
    backgroundColor: theme.palette.background.dark,
    padding: theme.spacing[3],
    color: theme.palette.text.light
  },
  textContainer: {
    '& *': {
      marginBottom: theme.spacing[4]
    }
  }
}));
const COPY$a = defineMessages({
  TITLE: {
    id: 'WordCloudPreviewOverlay.TITLE',
    defaultMessage: 'Try it out!',
    description: '[Type: Button][Vis: med] - Title for preview overlay'
  },
  SUBTITLE: {
    id: 'WordCloudPreviewOverlay.SUBTITLE',
    defaultMessage: 'Preview the features for customizing word clouds.',
    description: '[Type: Button][Vis: med] - Text displayed in preview overlay'
  },
  OK_BUTTON: {
    id: 'WordCloudPreviewOverlay.OK_BUTTON',
    defaultMessage: 'OK',
    description: '[Type: Button][Vis: med] - Button to close preview overlay'
  },
  CLOSE_ICON: {
    id: 'WordCloudPreviewOverlay.CLOSE_ICON',
    defaultMessage: 'Close button',
    description: '[Type: Button][Vis: med] - Icon shown in close button'
  }
});
function WordCloudPreviewOverlay({
  onCloseClick
}) {
  const {
    overlayContainer,
    overlayCta,
    textContainer
  } = useStyles$b();
  const closeOverlay = () => {
    onCloseClick(false);
  };
  return React__default.createElement(Box, {
    className: overlayContainer,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }, React__default.createElement("div", {
    className: overlayCta
  }, React__default.createElement(Box, {
    display: "flex",
    justifyContent: "flex-end"
  }, React__default.createElement(Button, {
    buttonType: "button",
    size: "sm",
    color: "muted",
    variant: "text",
    onClick: closeOverlay,
    label: t(COPY$a.CLOSE_ICON)
  }, React__default.createElement(IconX, {
    title: t(COPY$a.CLOSE_ICON)
  }))), React__default.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    className: textContainer
  }, React__default.createElement(Typography, {
    color: "upgrade",
    variant: "body"
  }, React__default.createElement(T, {
    desc: COPY$a.TITLE
  })), React__default.createElement(Typography, {
    color: "light"
  }, React__default.createElement(T, {
    desc: COPY$a.SUBTITLE
  })), React__default.createElement(Button, {
    buttonType: "button",
    size: "sm",
    color: "muted",
    onClick: closeOverlay
  }, React__default.createElement(T, {
    desc: COPY$a.OK_BUTTON
  })))));
}
const COPY$9 = defineMessages({
  LOADING: {
    id: 'WordCloudLoadingState.LOADING',
    defaultMessage: 'Loading word cloud...',
    description: '[Type: body][Vis: med] - indicated the view is loading'
  }
});
function WordCloudLoadingState() {
  return React__default.createElement("div", null, React__default.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    mt: 5,
    mb: 5,
    py: 9
  }, React__default.createElement(ProgressCircle, {
    continuous: true,
    valueText: t(COPY$9.LOADING)
  }), React__default.createElement(Box, {
    mt: 3
  }, React__default.createElement(Typography, {
    variant: "body"
  }, React__default.createElement(T, {
    desc: COPY$9.LOADING
  })))));
}
const COPY$8 = defineMessages({
  LIST_VIEW_BTN: {
    id: 'WordCloudShowCustomization.LIST_VIEW_BTN',
    defaultMessage: 'List View',
    description: '[Type: button][Vis: med] - set the view to list'
  },
  CLOUD_VIEW_BTN: {
    id: 'WordCloudShowCustomization.CLOUD_VIEW_BTN',
    defaultMessage: 'Cloud View',
    description: '[Type: button][Vis: med] - set the view to cloud'
  }
});
function WordCloudShowCustomization({
  currentView,
  setCurrentView,
  wordCloudStatus,
  setShowCustomization
}) {
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Box, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    py: 3
  }, React__default.createElement(ButtonGroup, null, React__default.createElement(Button, {
    variant: currentView === 'cloud' ? 'solid' : 'ghost',
    size: "sm",
    color: "secondary",
    onClick: () => setCurrentView('cloud')
  }, React__default.createElement(T, {
    desc: COPY$8.CLOUD_VIEW_BTN
  })), React__default.createElement(Button, {
    size: "sm",
    variant: currentView === 'list' ? 'solid' : 'ghost',
    color: "secondary",
    onClick: () => setCurrentView('list')
  }, React__default.createElement(T, {
    desc: COPY$8.LIST_VIEW_BTN
  })))), React__default.createElement(Keyline$1, null), wordCloudStatus === 'success' && currentView === 'cloud' && React__default.createElement(WordCloudCustomizationButton, {
    setShowCustomization: setShowCustomization
  }));
}
const useCustomizationProps = wordCloudCustomizationProps => {
  const [customizationProps, setCustomizationProps] = useState(wordCloudCustomizationProps);
  const prevCustomizationProps = useRef(wordCloudCustomizationProps);
  useEffect(() => {
    prevCustomizationProps.current = customizationProps;
  }, [customizationProps]);
  const updateCustomizationProps = updatedCustomizationProps => {
    setCustomizationProps(previousCustomizationProps => {
      const updatedProps = {
        ...previousCustomizationProps,
        ...updatedCustomizationProps
      };
      return updatedProps;
    });
  };
  return [customizationProps, prevCustomizationProps.current, updateCustomizationProps];
};
const useWordCloudPanelState = initState => {
  const [state, setState] = useState(() => initState);
  const setCurrentView = newCurrentView => {
    setState(prevState => {
      return {
        ...prevState,
        currentView: newCurrentView
      };
    });
  };
  const setShowHideCustomization = newShowCustomization => {
    setState(prevState => {
      return {
        ...prevState,
        showCustomization: newShowCustomization
      };
    });
  };
  const setShowHideWordsModal = newShowHideWordsModal => {
    setState(prevState => {
      return {
        ...prevState,
        showHideWordsModal: newShowHideWordsModal
      };
    });
  };
  const setShowHideCombinedWordsModal = newShowCombinedWordsModal => {
    setState(prevState => {
      return {
        ...prevState,
        showCombinedWordsModal: newShowCombinedWordsModal
      };
    });
  };
  const setCombineModalTriggerWord = newCombineModalTriggerWord => {
    setState(prevState => {
      return {
        ...prevState,
        combineModalTriggerWord: newCombineModalTriggerWord
      };
    });
  };
  const setShowHideWordCloudPreviewOverlay = setShowWordCloudPreviewOverlay => {
    setState(prevState => {
      return {
        ...prevState,
        showWordCloudPreviewOverlay: setShowWordCloudPreviewOverlay
      };
    });
  };
  return {
    state,
    setCurrentView,
    setShowHideCustomization,
    setShowHideWordsModal,
    setShowHideCombinedWordsModal,
    setCombineModalTriggerWord,
    setShowHideWordCloudPreviewOverlay
  };
};
const initState = (initialView, accessType) => {
  return {
    currentView: initialView,
    showCustomization: false,
    showHideWordsModal: false,
    showCombinedWordsModal: false,
    combineModalTriggerWord: undefined,
    showWordCloudPreviewOverlay: accessType !== ACCESS_TYPE.FULL
  };
};
function WordCloudPanel({
  initialView = 'cloud',
  words = [],
  wordCloudStatus = 'inProgress',
  wordCloudCustomizationProps,
  accessType,
  redirectLink,
  onSaveWordCloudCustomization,
  onWordClick
}) {
  const [minRange, maxRange] = getMinAndMaxRange(words);
  const {
    state,
    setCurrentView,
    setShowHideCustomization,
    setShowHideWordsModal,
    setShowHideCombinedWordsModal,
    setCombineModalTriggerWord,
    setShowHideWordCloudPreviewOverlay
  } = useWordCloudPanelState(initState(initialView, accessType));
  const [customizationProps, prevCustomizationProps, updateCustomizationProps] = useCustomizationProps(wordCloudCustomizationProps);
  const {
    minFrequency,
    hiddenWords,
    combinedWords
  } = customizationProps;
  const formattedWords = useMemo(() => formatWords(words, hiddenWords, combinedWords), [combinedWords, hiddenWords, words]);
  const filteredWords = useMemo(() => filterWordsByFrequency(formattedWords, minFrequency), [formattedWords, minFrequency]);
  const onSelectedColorPaletteChange = selectedColorPaletteId => {
    updateCustomizationProps({
      selectedColorPaletteId,
      isMultiColorSelected: true
    });
  };
  const onFontChange = e => {
    var _e$target$attributes$;
    const value = (_e$target$attributes$ = e.target.attributes.getNamedItem('data-value')) === null || _e$target$attributes$ === void 0 ? void 0 : _e$target$attributes$.value;
    updateCustomizationProps({
      fontFamily: value
    });
  };
  const toggleMultiColorSelector = () => {
    updateCustomizationProps({
      isMultiColorSelected: !customizationProps.isMultiColorSelected
    });
  };
  const onSliderChange = debounce(evt => {
    const [min] = evt.values;
    updateCustomizationProps({
      minFrequency: min
    });
  }, 400);
  const onFixedColorChange = debounce(fixedColor => {
    updateCustomizationProps({
      fixedColor,
      isMultiColorSelected: false
    });
  }, 400);
  const onSaveWordCloudCustomizationClick = applyToAll => {
    onSaveWordCloudCustomization(customizationProps, applyToAll);
    setShowHideCustomization(false);
  };
  const onCancelWordCloudCustomizationClick = () => {
    setShowHideCustomization(false);
    updateCustomizationProps(prevCustomizationProps);
  };
  const onHideFromWordCloudLinkClick = triggerWord => {
    const updateHiddenWords = [...customizationProps.hiddenWords, triggerWord];
    updateCustomizationProps({
      hiddenWords: updateHiddenWords
    });
    onSaveWordCloudCustomization({
      ...customizationProps,
      hiddenWords: updateHiddenWords
    }, true);
  };
  const onCombineWord = formData => {
    if (formData.title) {
      const existingCombinedWord = customizationProps.combinedWords.filter(obj => obj.title !== formData.title);
      const updateCombinedWords = [...existingCombinedWord, {
        title: formData.title,
        words: getSelectedWordsForCustomization(formData)
      }];
      updateCustomizationProps({
        combinedWords: updateCombinedWords
      });
      onSaveWordCloudCustomization({
        ...customizationProps,
        combinedWords: updateCombinedWords
      }, true);
    }
    setCombineModalTriggerWord(undefined);
  };
  const handleSplitCombinedWords = word => {
    const updateCombinedWords = customizationProps.combinedWords.filter(w => {
      var _word$combinedWord;
      return w.title !== ((_word$combinedWord = word.combinedWord) === null || _word$combinedWord === void 0 ? void 0 : _word$combinedWord.title);
    });
    updateCustomizationProps({
      combinedWords: updateCombinedWords
    });
    onSaveWordCloudCustomization({
      ...customizationProps,
      combinedWords: updateCombinedWords
    }, true);
  };
  const handleEditCombinedWords = word => {
    setShowHideCombinedWordsModal(true);
    setCombineModalTriggerWord(word);
  };
  const handleCombineModalClose = () => {
    setShowHideCombinedWordsModal(false);
    setCombineModalTriggerWord(undefined);
  };
  const handleUpdateHiddenWords = formData => {
    const updateHiddenWords = getSelectedWordsForCustomization(formData);
    updateCustomizationProps({
      hiddenWords: updateHiddenWords
    });
    onSaveWordCloudCustomization({
      ...customizationProps,
      hiddenWords: updateHiddenWords
    }, true);
  };
  const {
    wordCloudBlur,
    wordCloudContainer
  } = useStyles$d();
  return React__default.createElement(Box, {
    color: "light"
  }, state.showCustomization && React__default.createElement(Box, null, React__default.createElement(WordCloudCustomization, {
    ...customizationProps,
    footerComponent: React__default.createElement(WordCloudListCustomizationFooter, {
      onSaveClick: onSaveWordCloudCustomizationClick,
      onCancelClick: onCancelWordCloudCustomizationClick,
      redirectLink: redirectLink
    }),
    isBasicUser: accessType !== ACCESS_TYPE.FULL,
    minRange: minRange,
    maxRange: maxRange,
    wordCount: filteredWords.length,
    onSliderChange: onSliderChange,
    onSaveMultiColorPaletteClick: onSelectedColorPaletteChange,
    onFontChange: onFontChange,
    onFixedColorChange: onFixedColorChange,
    toggleMultiColorSelector: toggleMultiColorSelector
  })), !state.showCustomization && React__default.createElement(WordCloudShowCustomization, {
    currentView: state.currentView,
    setCurrentView: setView => setCurrentView(setView),
    setShowCustomization: () => setShowHideCustomization(true),
    wordCloudStatus: wordCloudStatus
  }), wordCloudStatus === 'inProgress' && React__default.createElement(WordCloudLoadingState, null), wordCloudStatus === 'success' && React__default.createElement("div", {
    className: wordCloudContainer
  }, state.showWordCloudPreviewOverlay && React__default.createElement(WordCloudPreviewOverlay, {
    onCloseClick: () => setShowHideWordCloudPreviewOverlay(false)
  }), React__default.createElement(Box, {
    mb: 3,
    className: state.showWordCloudPreviewOverlay ? wordCloudBlur : ''
  }, React__default.createElement(WordCloudViewSelector, {
    ...customizationProps,
    currentView: state.currentView,
    words: filteredWords,
    fontFamily: getFontStyle(customizationProps.fontFamily),
    onWordClick: onWordClick,
    onCombineWordLinkClick: handleEditCombinedWords,
    onHideFromWordCloudLinkClick: onHideFromWordCloudLinkClick,
    onSplitCombinedWords: handleSplitCombinedWords,
    onEditCombinedWords: handleEditCombinedWords
  }))), React__default.createElement(Keyline$1, null), React__default.createElement(WordCloudListFooter, {
    accessType: accessType,
    redirectLink: redirectLink,
    status: wordCloudStatus,
    wordCount: filteredWords.length,
    combinedWordsCount: combinedWords.length,
    hiddenWordsCount: hiddenWords.length,
    onCombineWordLinkClick: handleEditCombinedWords,
    onHiddenWordsLinkClick: () => setShowHideWordsModal(true)
  }), state.showCombinedWordsModal && React__default.createElement(CombineWordsModal, {
    words: filteredWords,
    showModal: state.showCombinedWordsModal,
    triggerWord: state.combineModalTriggerWord,
    onCombine: onCombineWord,
    onClose: handleCombineModalClose
  }), state.showHideWordsModal && React__default.createElement(HideWordsModal, {
    words: words,
    showModal: state.showHideWordsModal,
    hiddenWords: hiddenWords,
    handleClose: () => setShowHideWordsModal(false),
    handleUpdateHiddenWords: handleUpdateHiddenWords
  }));
}
const useStyles$a = createUseStyles({
  container: {
    border: '1px solid #D0D0D0',
    boxShadow: '0px 0px 15px 1px rgba(64, 64, 64, 0.1)',
    borderRadius: 8
  },
  contentWrapper: {
    flex: '1 1 0%',
    overflow: 'hidden',
    position: 'relative'
  }
});
function SolutionsCard({
  children
}) {
  const {
    contentWrapper,
    container
  } = useStyles$a();
  return React__default.createElement("div", {
    className: container
  }, React__default.createElement("div", {
    className: contentWrapper
  }, children));
}
const useStyles$9 = createUseStyles(theme => {
  return {
    container: {
      border: theme.border.main,
      boxShadow: `0 0 15px 1px rgba(64, 64, 64, 0.1)`,
      borderRadius: 8
    },
    questionViewHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      minHeight: '71px',
      padding: [theme.spacing[6], theme.spacing[6], theme.spacing[2], theme.spacing[6]] // padding: '32px 32px 8px 32px',
    },

    questionNum: {
      margin: theme.spacing[2]
    },
    questionTitle: {
      padding: [0, theme.spacing[6], theme.spacing[6], theme.spacing[6]] // padding: '0px 32px 32px 32px',
    },

    cardWrapper: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      width: '100%'
    },
    contentWrapper: {
      padding: [0, theme.spacing[6], theme.spacing[6], theme.spacing[6]],
      flex: '1 1 0%',
      overflow: 'hidden',
      position: 'relative'
    }
  };
});
const COPY$7 = defineMessages({
  QUESTION_NUMBER: {
    id: 'SolutionsCardLayoutTemplate.QUESTION_NUMBER',
    defaultMessage: 'Q{questionNumber} {questionHeader}',
    description: '[Type: label][Vis: high] - text to indicate question number'
  },
  QUESTION_TITLE: {
    id: 'SolutionsCardLayoutTemplate.QUESTION_TITLE',
    defaultMessage: '{title}',
    description: '[Type: label][Vis: medium] - text to indicate question title'
  }
});
function SolutionsCardLayoutTemplate({
  questionNumber,
  questionHeader,
  children,
  title
}) {
  const {
    contentWrapper,
    questionViewHeader,
    questionTitle
  } = useStyles$9();
  return React__default.createElement(SolutionsCard, null, React__default.createElement("div", {
    className: questionViewHeader
  }, React__default.createElement(Typography, {
    variant: "cardTitle",
    color: "dark",
    component: "strong"
  }, React__default.createElement(T, {
    desc: COPY$7.QUESTION_NUMBER,
    values: {
      questionNumber,
      questionHeader
    }
  }))), React__default.createElement("div", {
    className: questionTitle,
    translate: "no"
  }, React__default.createElement(Typography, {
    variant: "bodySm"
  }, React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: sanitizeString(title || '', {
        ALLOWED_TAGS: ['strong']
      })
    }
  }))), React__default.createElement("div", {
    className: contentWrapper
  }, children));
}
const useStyles$8 = createUseStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
  }
});
const COPY$6 = {
  ICON_LABEL: 'No matching responses.'
};
function ResponseError() {
  const {
    container
  } = useStyles$8();
  return React__default.createElement("div", {
    className: container
  }, React__default.createElement(Typography, {
    align: "center",
    variant: "bodySm"
  }, React__default.createElement(IconWarning, {
    size: "sm",
    role: "presentation",
    title: ""
  }), " ", COPY$6.ICON_LABEL));
}
const useStyles$7 = createUseStyles(theme => ({
  /** for some reason, @wds/box doesn't play nice */
  box: {
    width: '100%',
    height: '100%',
    padding: [0, theme.spacing[3]]
  }
}));
const wordCloudCustomizationProps = {
  colorPaletteOptions: [{
    groupId: 1,
    palette: ['#6bc8cd', '#56b0cd', '#5c96c4', '#6e7bb0', '#7d5e90'],
    scales: ['#6bc8cd', '#5cbbce', '#55adcd', '#589ec8', '#618fc0', '#6c7fb4', '#766ea4', '#7d5e90']
  }, {
    groupId: 2,
    palette: ['#ff8b4f', '#f3716e', '#d66486', '#ac6093', '#7d5e90'],
    scales: ['#ff8b4f', '#fb7b61', '#f06f72', '#e06780', '#cb638b', '#b26192', '#986093', '#7d5e90']
  }, {
    groupId: 3,
    palette: ['#6bc8dc', '#54b8e2', '#7ba0e5', '#b280ca', '#d25f90'],
    scales: ['#6bc8dc', '#57coda', '#56b5e4', '#6ca7e7', '#8c97e1', '#ab84d0', '#c471b4', '#d25f90']
  }],
  selectedColorPaletteId: 1,
  fontFamily: 'National 2',
  fixedColor: DEFAULT_COLOR,
  isMultiColorSelected: false,
  minRange: -1,
  maxRange: 1000,
  minFrequency: -1,
  wordCount: 5,
  onSaveMultiColorPaletteClick: EmptyFn,
  onSliderChange: EmptyFn,
  toggleMultiColorSelector: EmptyFn,
  onFixedColorChange: EmptyFn,
  onFontChange: EmptyFn,
  combinedWords: [],
  hiddenWords: []
};
function SolutionsOpenEndedItem({
  words,
  onSearch,
  ...props
}) {
  const onWordClick = useCallback(word => {
    // setSelectedTab('responses');
    if (word.combinedWord) {
      // This is to prepend and append `"` to the string, the search phrase `"heard new file" OR "new File Upload"` and `heard new file OR new file upload` yield different result
      const combinedSearchPhrase = word.combinedWord.words.map(combinedWord => {
        return `"${combinedWord}"`;
      }).join(' OR ');
      onSearch(combinedSearchPhrase);
      return;
    }
    onSearch(`${word.word}`);
  }, [onSearch]);
  const {
    box
  } = useStyles$7();
  const hasWords = words && words.length > 0;
  return React__default.createElement(SolutionsCardLayoutTemplate, {
    ...props
  }, React__default.createElement("div", {
    className: box
  }, hasWords ? React__default.createElement(WordCloudPanel, {
    accessType: ACCESS_TYPE.FULL,
    redirectLink: "",
    words: words,
    wordCloudStatus: "success",
    wordCloudCustomizationProps: wordCloudCustomizationProps,
    onSaveWordCloudCustomization: EmptyFn,
    onWordClick: onWordClick
  }) : React__default.createElement(ResponseError, null)));
}
var SolutionsOpenEndedItem$1 = withErrorBoundary(SolutionsOpenEndedItem);

/** checks for `{name: string, data: any}[]` */
const isTwoDimensionalChartData = a => Array.isArray(a) && a.every(i => typeof i === 'object' && 'name' in i && 'data' in i && i.data.every(d => typeof d === 'number' || typeof d === 'object'));
/* checks for `{value: any}` */
const isScalarChartData = a => typeof a === 'object' && a !== null && 'value' in a;
// Chart Type Guards
const isBarChartData = a => {
  return Array.isArray(a) && a.every(i => typeof i === 'number') || isTwoDimensionalChartData(a);
};
const isStackedBarChartData = a => isTwoDimensionalChartData(a);
const isLineChartData = a => isTwoDimensionalChartData(a);
const isAreaChartData = a => isTwoDimensionalChartData(a);
const isPieOrDonutChartData = a => {
  return Array.isArray(a) && a.every(i => 'name' in i && 'value' in i && 'numberOfResponses' in i);
};
const isNpsGaugeChartData = a => isScalarChartData(a);
const isRatingChartData = a => isScalarChartData(a);
const isVanWestendorpChartData = a => {
  return typeof a === 'object' && a !== null && 'series' in a && 'metadata' in a;
};
const isChartData = a => Array.isArray(a) && a.length > 0 || isRatingChartData(a) || isNpsGaugeChartData(a);
const splitLabel = str => {
  if (typeof str === 'string' && str.length < 13) {
    return 13;
  }
  for (let i = 13; i >= 0; i -= 1) {
    if (typeof str === 'string' && str.charAt(i) === ' ') {
      return i;
    }
  }
  return 11;
};
const formatLabelVerticalAxis = ({
  value
}) => {
  const newValue = value.toString();
  const splitPoint = splitLabel(newValue);
  const strTop = newValue.slice(0, splitPoint);
  const strBottom = newValue.slice(splitPoint, newValue.length);
  return `<div aria-label='${value}' title='${value}' align="center" style="width:60px;">
<div style="text-align: right">
${strTop}
</div>
<div style="overflow:hidden; text-overflow:ellipsis; max-height:14px; text-align:end; width:60px">
${strBottom}
</div>
</div>`;
};
function formatLabelHorizontalAxis(label) {
  const labelClipped = label.substring(0, 80);
  return label.length > 76 ? `${labelClipped}...` : label;
}
function getWDSIconFromChartIcon(chartIcon) {
  const iconMap = {
    STAR: IconStarFilled,
    SMILEY: IconHappyFilled,
    HEART: IconHeartFilled,
    THUMB: IconThumbsUpFilled
  };
  if (typeof chartIcon === 'string') {
    return iconMap[chartIcon];
  }
  return chartIcon;
}
const defaultChartColors = ['#00BF6F', '#507CB6', '#F9BE00', '#6BC8CD', '#FF8B4F', '#7D5E90', '#D25F90', '#C7B879', '#DB4D5C', '#768086'];
const themedOptions = theme => ({
  colors: defaultChartColors,
  chart: {
    spacingRight: 0,
    style: {
      fontFamily: theme.type.fontFamily.base
    },
    plotBackgroundColor: theme.palette.background.light
  },
  title: {
    style: {
      fontFamily: theme.type.fontFamily.base,
      fontWeight: theme.type.fontWeight.medium.toString(),
      fontSize: theme.type.fontSize.cardTitle.toString(),
      color: theme.palette.text.dark
    },
    text: '' // remove the chart title by default
  },

  xAxis: {
    title: {
      text: null // use "null" to hide x-axis title
    },

    labels: {
      style: {
        fontFamily: theme.type.fontFamily.base,
        fontWeight: theme.type.fontWeight.regular.toString(),
        color: theme.palette.text.dark,
        maxWidth: 10
      },
      overflow: 'justify',
      useHTML: true,
      formatter() {
        const label = this.axis.defaultLabelFormatter.call(this);
        // TODO: revisit this after dropping IE11 support
        return formatLabelHorizontalAxis(label);
      }
    },
    lineColor: theme.palette.border.main,
    tickLength: 0
  },
  yAxis: {
    // Do not change to an array.  Keep as single object.  See BarChart.tsx type assertion for YAxisOptions.
    labels: {
      overflow: 'justify',
      style: {
        fontFamily: theme.type.fontFamily.base,
        paddingTop: theme.spacing[3],
        fontWeight: theme.type.fontWeight.regular.toString(),
        color: theme.palette.text.dark
      },
      useHTML: true
    },
    title: {
      text: null
    },
    offset: 0,
    lineColor: theme.palette.border.main,
    lineWidth: 1,
    gridLineColor: theme.palette.border.muted
  },
  plotOptions: {
    series: {
      animation: false,
      enableMouseTracking: false,
      dataLabels: {
        style: {
          fontWeight: theme.type.fontWeight.medium.toString(),
          fontSize: theme.type.fontSize.bodySm.toString(),
          color: theme.palette.text.dark,
          textShadow: `-1px -1px 0 ${theme.palette.text.light}, 1px -1px 0 ${theme.palette.text.light}, -1px 1px 0 ${theme.palette.text.light}, 1px 1px 0 ${theme.palette.text.light}`
        },
        useHTML: true
      },
      point: {
        events: {
          legendItemClick() {
            return false;
          }
        }
      },
      events: {
        legendItemClick() {
          return false; // disables legend item toggling
        }
      },

      states: {
        hover: {
          enabled: false
        },
        inactive: {
          enabled: false
        }
      }
    }
  },
  legend: {
    labelFormatter() {
      return `<div style="
      overflow: hidden;
      text-overflow: ellipsis;
      ">${this.name}</div>`;
    },
    enabled: false,
    floating: false,
    borderWidth: 0,
    symbolRadius: 2,
    x: 0,
    y: 5,
    useHTML: true,
    itemDistance: 20,
    itemStyle: {
      color: theme.palette.text.dark,
      fontFamily: theme.type.fontFamily.base,
      fontSize: theme.type.fontSize.bodySm.toString(),
      fontWeight: theme.type.fontWeight.light.toString(),
      lineHeight: '20px'
    },
    itemHoverStyle: {
      color: theme.palette.text.dark
    }
  },
  tooltip: {
    animation: false,
    hideDelay: 100,
    backgroundColor: theme.palette.background.dark,
    borderWidth: 0,
    shadow: false,
    headerFormat: '',
    followPointer: true,
    style: {
      fontFamily: theme.type.fontFamily.base,
      fontSize: theme.type.fontSize.bodySm.toString(),
      color: theme.palette.text.dark
    },
    useHTML: true
  },
  credits: {
    enabled: false
  },
  accessibility: {
    enabled: true
  }
});
const useDefaultOptions = () => {
  const theme = useTheme();
  return themedOptions(theme);
};
HighchartsAccessibility(Highcharts);
// support additional HTML/SVG attributes
(_Highcharts$AST = Highcharts.AST) === null || _Highcharts$AST === void 0 ? void 0 : _Highcharts$AST.allowedAttributes.push('align');
(_Highcharts$AST2 = Highcharts.AST) === null || _Highcharts$AST2 === void 0 ? void 0 : _Highcharts$AST2.allowedAttributes.push('title');
const useStyles$6 = createUseStyles({
  container: {
    '& .highcharts-container': {
      direction: 'inherit'
    }
  }
});
/** Wrapper around `HighchartsReact` with default values - base of all other charts */
function BaseChart({
  options
}) {
  const base = useDefaultOptions();
  const {
    container
  } = useStyles$6();
  return React__default.createElement(HighchartsReact, {
    containerProps: {
      style: {
        width: '100%',
        height: '100%'
      },
      className: container
    },
    highcharts: Highcharts,
    options: merge(base, options)
  });
}
const getBarChartOptions = (data, options, isPercentage = false, decimalPlaces = 0) => {
  return merge(
  // overwritable defaults
  {
    plotOptions: {
      bar: {
        colorByPoint: true,
        dataLabels: {
          format: `{y:.${decimalPlaces}f}${isPercentage ? '%' : ''}`,
          inside: false
        }
      }
    },
    xAxis: {
      labels: {
        formatter: formatLabelVerticalAxis
      }
    },
    yAxis: {
      labels: {
        format: `{value}${isPercentage ? '%' : ''}`
      }
    }
  }, options,
  // not overwritable
  {
    series: isTwoDimensionalChartData(data) ? data.map(d => ({
      ...d,
      type: 'bar'
    })) : [{
      data,
      type: 'bar'
    }]
  });
};
function BarChart({
  data,
  options,
  isPercentage,
  decimalPlaces
}) {
  const barChartOptions = getBarChartOptions(data, options, isPercentage, decimalPlaces);
  return React__default.createElement(BaseChart, {
    options: barChartOptions
  });
}
const getColumnChartOptions = (data, options, isPercentage = false, decimalPlaces = 0) => {
  return merge(
  // overwritable defaults
  {
    plotOptions: {
      column: {
        colorByPoint: true,
        dataLabels: {
          format: `{y:.${decimalPlaces}f}${isPercentage ? '%' : ''}`,
          inside: false
        }
      }
    },
    yAxis: {
      labels: {
        format: `{value}${isPercentage ? '%' : ''}`
      }
    }
  }, options,
  // not overwritable
  {
    series: isTwoDimensionalChartData(data) ? data.map(d => ({
      ...d,
      type: 'column'
    })) : [{
      data,
      type: 'column'
    }]
  });
};
function ColumnChart({
  data,
  options,
  isPercentage,
  decimalPlaces
}) {
  const columnChartOptions = getColumnChartOptions(data, options, isPercentage, decimalPlaces);
  return React__default.createElement(BaseChart, {
    options: columnChartOptions
  });
}
function getPieChartOptions(data, options) {
  const pieChartData = {
    data: data.map(({
      value,
      ...dataOptions
    }) => {
      const chartData = typeof value === 'number' ? {
        y: value
      } : value;
      return {
        ...chartData,
        ...dataOptions
      };
    }),
    type: 'pie'
  };
  return merge(options,
  // not overwritable
  {
    series: [pieChartData],
    chart: {
      type: 'pie'
    }
  });
}
function PieChart({
  data,
  options
}) {
  const pieChartOptions = getPieChartOptions(data, options);
  return React__default.createElement(BaseChart, {
    options: pieChartOptions
  });
}

/** Build Donut specific options - rest is done in PieChart */
const getDonutChartOptions = options => merge(
// overwritable defaults
{
  plotOptions: {
    pie: {
      innerSize: '40%'
    }
  }
}, options);
/** Donut chart is a special type of PieChart (and uses it internally) */
function DonutChart({
  data,
  options
}) {
  const donutChartOptions = getDonutChartOptions(options);
  return React__default.createElement(PieChart, {
    data: data,
    options: donutChartOptions
  });
}
const getStackedBarChartOptions = (data, options, isPercentage = false, showLabels = false, decimalPlaces = 0) => {
  const series = data.map(stack => ({
    ...stack,
    type: 'bar'
  }));
  return merge(
  // overwritable defaults
  {
    legend: {
      enabled: true,
      reversed: true // reverse series labels have have same order as `data` (Highcharts flips them) ref: https://www.highcharts.com/demo/bar-stacked
    },

    plotOptions: {
      bar: {
        stacking: isPercentage ? 'percentage' : 'normal',
        dataLabels: {
          format: `{y:.${decimalPlaces}f}${isPercentage ? '%' : ''}`,
          style: {
            textOutline: '1px contrast'
          },
          useHTML: false // needed for textOutline
        },

        groupPadding: 0,
        maxPointWidth: 100 // TODO: refine this
      }
    },

    xAxis: {
      labels: {
        enabled: showLabels
      }
    },
    yAxis: {
      labels: {
        format: `{value}${isPercentage ? '%' : ''}`
      }
    }
  }, options,
  // not overwritable
  {
    series,
    chart: {
      type: 'bar'
    }
  });
};
function StackedBarChart({
  data,
  options,
  isPercentage,
  showLabels,
  decimalPlaces
}) {
  const barChartOptions = getStackedBarChartOptions(data.slice().reverse(),
  // reverse series data have have same order as data inserted (Highcharts flips them)
  options, isPercentage, showLabels, decimalPlaces);
  return React__default.createElement(BaseChart, {
    options: barChartOptions
  });
}
const getStackedColumnChartOptions = (data, options, isPercentage = false, showLabels = false, decimalPlaces = 0) => {
  const series = data.map(stack => ({
    ...stack,
    type: 'column'
  }));
  return merge(
  // overwritable defaults
  {
    legend: {
      enabled: true,
      reversed: true // reverse series labels have have same order as `data` (Highcharts flips them) ref: https://www.highcharts.com/demo/bar-stacked
    },

    plotOptions: {
      column: {
        stacking: isPercentage ? 'percentage' : 'normal',
        dataLabels: {
          format: `{y:.${decimalPlaces}f}${isPercentage ? '%' : ''}`,
          style: {
            textOutline: '1px contrast'
          },
          useHTML: false // needed for textOutline
        },

        groupPadding: 0,
        maxPointWidth: 100 // TODO: refine this
      }
    },

    xAxis: {
      labels: {
        enabled: showLabels
      }
    },
    yAxis: {
      labels: {
        format: `{value}${isPercentage ? '%' : ''}`
      }
    }
  }, options,
  // not overwritable
  {
    series,
    chart: {
      type: 'column'
    }
  });
};
function StackedColumnChart({
  data,
  options,
  isPercentage,
  showLabels,
  decimalPlaces
}) {
  const columnChartOptions = getStackedColumnChartOptions(data.slice().reverse(),
  // reverse series data have have same order as data inserted (Highcharts flips them)
  options, isPercentage, showLabels, decimalPlaces);
  return React__default.createElement(BaseChart, {
    options: columnChartOptions
  });
}
const getLineChartOptions = (data, options, isPercentage = false, decimalPlaces = 0) => {
  const series = data.map(el => ({
    ...el,
    type: 'line'
  }));
  return merge(
  // overwritable defaults
  {
    plotOptions: {
      line: {
        dataLabels: {
          enabled: true,
          format: `{y:.${decimalPlaces}f}${isPercentage ? '%' : ''}`,
          style: {
            textOutline: '1px contrast'
          },
          useHTML: false // needed for textOutline
        }
      }
    },

    tooltip: {
      // TODO: add show tooltip
      enabled: false
    },
    yAxis: {
      labels: {
        format: `{value}${isPercentage ? '%' : ''}`
      }
    }
  }, options,
  // not overwritable
  {
    series,
    chart: {
      type: 'line'
    }
  });
};
function LineChart({
  data,
  options,
  isPercentage,
  decimalPlaces
}) {
  const lineChartOptions = getLineChartOptions(data, options, isPercentage, decimalPlaces);
  return React__default.createElement(BaseChart, {
    options: lineChartOptions
  });
}
const getAreaChartOptions = (data, options, isPercentage = false, isStackable = false, decimalPlaces = 0) => {
  const series = data.map(el => ({
    ...el,
    type: 'area'
  }));
  return merge(
  // overwritable defaults
  {
    plotOptions: {
      area: {
        dataLabels: {
          enabled: true,
          format: `{y:.${decimalPlaces}f}${isPercentage ? '%' : ''}`,
          style: {
            textOutline: '1px contrast'
          },
          useHTML: false // needed for textOutline
        },

        stacking: isStackable && isPercentage ? 'percent' : 'normal'
      }
    },
    tooltip: {
      // TODO: add show tooltip
      enabled: false
    },
    yAxis: {
      labels: {
        format: isPercentage ? '{value}%' : '{value}'
      },
      reversedStacks: false
    }
  }, options,
  // not overwritable
  {
    series,
    chart: {
      type: 'area'
    }
  });
};
function AreaChart({
  data,
  options,
  isPercentage,
  isStackable,
  decimalPlaces
}) {
  const areaChartOptions = getAreaChartOptions(data, options, isPercentage, isStackable, decimalPlaces);
  return React__default.createElement(BaseChart, {
    options: areaChartOptions
  });
}
const useStyles$5 = createUseStyles(theme => {
  return {
    cellPaddingBottom: {
      paddingBottom: theme.spacing[2]
    },
    cellPaddingTop: {
      paddingTop: theme.spacing[2]
    },
    divider: {
      height: '0px',
      borderBottom: theme.border.main
    },
    table: {
      width: '275px',
      color: theme.palette.text.dark,
      fontSize: theme.type.fontSize.bodySm
    },
    tablePadding: {
      paddingTop: theme.spacing[5]
    },
    title: {
      fontWeight: theme.type.fontWeight.medium
    },
    numeric: {
      textAlign: 'right'
    }
  };
});

/**
 * @file Provides the helper functions & types for the vanwestendorp chart.
 */
const COPY$5 = defineMessages({
  OPP_TITLE: {
    id: 'helper.OPP_TITLE',
    defaultMessage: 'OPP',
    description: '[Type: Label][Vis: med] - OPP title'
  },
  OPP_FULL_FORM: {
    id: 'helper.OPP_DESCRIPTION',
    defaultMessage: 'Optimal price point',
    description: '[Type: Label][Vis: med] - OPP'
  },
  PMC_TITLE: {
    id: 'helper.PMC_TITLE',
    defaultMessage: 'PMC',
    description: '[Type: Label][Vis: med] - PMC title'
  },
  PMC_FULL_FORM: {
    id: 'helper.POINT_OF_MARGINAL_CHEAPNESS',
    defaultMessage: 'Point of marginal cheapness',
    description: '[Type: Label][Vis: med] - Point of marginal cheapness'
  },
  PME_TITLE: {
    id: 'helper.PME_TITLE',
    defaultMessage: 'PME',
    description: '[Type: Label][Vis: med] - PME title'
  },
  PME_FULL_FORM: {
    id: 'helper.POINT_OF_MARGINAL_EXPENSIVENESS',
    defaultMessage: 'Point of marginal expensiveness',
    description: '[Type: Label][Vis: med] - Point of marginal expensiveness'
  },
  IPP_TITLE: {
    id: 'helper.IPP_TITLE',
    defaultMessage: 'IPP',
    description: '[Type: Label][Vis: med] - IPP title'
  },
  IPP_FULL_FORM: {
    id: 'helper.INDIFFERENCE_PRICE_POINT',
    defaultMessage: 'Indifference price point',
    description: '[Type: Label][Vis: med] - Indifference Price Point'
  },
  OPP: {
    id: 'helper.OPP',
    defaultMessage: 'Optimal price point (OPP)',
    description: '[Type: Label][Vis: med] - OPP'
  },
  PMC: {
    id: 'helper.PMC',
    defaultMessage: 'Point of marginal cheapness (PMC)',
    description: '[Type: Label][Vis: med] - PMC'
  },
  PME: {
    id: 'helper.PME',
    defaultMessage: 'Point of marginal expensiveness (PME)',
    description: '[Type: Label][Vis: med] - PME'
  },
  IPP: {
    id: 'helper.IPP',
    defaultMessage: 'Indifference price point (IPP)',
    description: '[Type: Label][Vis: med] - IPP'
  }
});
// Provides data to different highChartSeries, tooltip key is used in datatable & series tooltip
const getHighchartSeriesData = data => {
  const {
    upperBound,
    indifferent,
    optimal,
    lowerBound
  } = data.metadata;
  const acceptableRange = [[lowerBound.price, 0.0], [lowerBound.price, 100.0], [upperBound.price, 100.0], [upperBound.price, 0]];
  const PME = {
    point: t(COPY$5.PME),
    title: t(COPY$5.PME_TITLE),
    description: t(COPY$5.PME_FULL_FORM),
    price: `$${new Intl.NumberFormat('en-US').format(upperBound.price)}`,
    percentage: `${upperBound.percentage.toFixed(2)}%`,
    response: `${upperBound.responses.toFixed(2)}`
  };
  const IPP = {
    point: t(COPY$5.IPP),
    title: t(COPY$5.IPP_TITLE),
    description: t(COPY$5.IPP_FULL_FORM),
    price: `$${new Intl.NumberFormat('en-US').format(indifferent.price)}`,
    percentage: `${indifferent.percentage.toFixed(2)}%`,
    response: `${indifferent.responses.toFixed(2)}`
  };
  const OPP = {
    point: t(COPY$5.OPP),
    title: t(COPY$5.OPP_TITLE),
    description: t(COPY$5.OPP_FULL_FORM),
    price: `$${new Intl.NumberFormat('en-US').format(optimal.price)}`,
    percentage: `${optimal.percentage.toFixed(2)}%`,
    response: `${optimal.responses.toFixed(2)}`
  };
  const PMC = {
    point: t(COPY$5.PMC),
    title: t(COPY$5.PMC_TITLE),
    description: t(COPY$5.PMC_FULL_FORM),
    price: `$${new Intl.NumberFormat('en-US').format(lowerBound.price)}`,
    percentage: `${lowerBound.percentage.toFixed(2)}%`,
    response: `${lowerBound.responses.toFixed(2)}`
  };
  const defaultPoint = [0, 0];
  const pointsOfInterest = [{
    tooltip: OPP,
    point: [optimal.price, parseFloat(optimal.percentage.toFixed(2))] ?? defaultPoint
  }, {
    tooltip: PMC,
    point: [lowerBound.price, parseFloat(lowerBound.percentage.toFixed(2))] ?? defaultPoint
  }, {
    tooltip: PME,
    point: [upperBound.price, parseFloat(upperBound.percentage.toFixed(2))] ?? defaultPoint
  }, {
    tooltip: IPP,
    point: [indifferent.price, parseFloat(indifferent.percentage.toFixed(2))] ?? defaultPoint
  }];
  return {
    pointsOfInterest,
    acceptableRange
  };
};
// Transform data into the highchart series format.
const getHighchartSeries = (data, pointsOfInterest, acceptableRange) => {
  const intersections = map(pointsOfInterest, 'point');
  const series = data.series.map(el => ({
    ...el
  }));
  series.push({
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    type: 'area',
    name: 'Acceptable price range',
    marker: {
      enabled: false
    },
    color: '#D2D2D2',
    opacity: 0.3,
    data: acceptableRange
  });
  series.push({
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    type: 'scatter',
    name: 'Points of interest',
    data: intersections,
    dataLabels: {
      enabled: true,
      formatter() {
        return `$${this.point.x.toFixed(2)}`;
      }
    },
    marker: {
      radius: 1.5,
      symbol: 'circle',
      fillColor: 'black',
      lineColor: 'black',
      lineWidth: 2
    },
    states: {
      inactive: {
        opacity: 1
      }
    },
    showInLegend: false
  });
  return series;
};
// Check if tooltip point is the pointOfInterest
const getIntersectionPoints = (pointsOfInterest, x, y) => {
  return pointsOfInterest.filter(seriesPoint => seriesPoint.point[0] === x && seriesPoint.point[1] === y) || [];
};

/**
 * @file Base page for the VanWestendorpChartDataTable steps of the Study Setup
 */
const COPY$4 = defineMessages({
  PRICE: {
    id: 'VanWestendorpChartDataTable.PRICE',
    defaultMessage: 'Price',
    description: '[Type: Label][Vis: med] -Price'
  },
  PERCENTAGE_OF_RESPONSES: {
    id: 'VanWestendorpChartDataTable.PERCENTAGE_OF_RESPONSES',
    defaultMessage: '% of responses',
    description: '[Type: Label][Vis: med] - Percentage of responses'
  },
  RESPONSES: {
    id: 'VanWestendorpChartDataTable.RESPONSES',
    defaultMessage: 'Responses',
    description: '[Type: Label][Vis: med] - Responses'
  }
});
function VanWestendorpChartDataTable({
  data
}) {
  const bodyRows = data.map(item => {
    return React__default.createElement(Table$1.Row, {
      key: `row-${item.title}`
    }, React__default.createElement(Table$1.HeaderCell, null, item.point), React__default.createElement(Table$1.Cell, null, item.price), React__default.createElement(Table$1.Cell, null, item.percentage), React__default.createElement(Table$1.Cell, null, item.response));
  });
  return React__default.createElement(Table$1, {
    xScroll: true
  }, React__default.createElement(Table$1.Header, null, React__default.createElement(Table$1.Row, null, React__default.createElement(Table$1.HeaderCell, null), React__default.createElement(Table$1.HeaderCell, null, t(COPY$4.PRICE)), React__default.createElement(Table$1.HeaderCell, null, t(COPY$4.PERCENTAGE_OF_RESPONSES)), React__default.createElement(Table$1.HeaderCell, null, t(COPY$4.RESPONSES)))), React__default.createElement(Table$1.Body, null, bodyRows));
}
const getVanWestendorpChartOptions = (series, xBoundaries, pointsOfInterest, options, classNames) => {
  return merge$1(
  // overridable defaults
  {
    title: '',
    legend: {
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'top',
      itemStyle: {
        fontFamily: 'National 2',
        fontWeight: '400',
        fontSize: '12px',
        color: '#404040'
      }
    },
    plotOptions: {
      series: {
        events: {
          legendItemClick() {
            return false;
          }
        }
      },
      line: {
        states: {
          inactive: {
            opacity: 1
          },
          hover: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        }
      }
    },
    tooltip: {
      backgroundColor: 'white',
      borderColor: 'white',
      borderRadius: 4,
      useHTML: true,
      padding: 24,
      formatter() {
        const intersectionPoints = getIntersectionPoints(pointsOfInterest, this.x, this.y);
        let result = '';
        for (let i = 0; i < (intersectionPoints === null || intersectionPoints === void 0 ? void 0 : intersectionPoints.length); i += 1) {
          const intersectionPoint = intersectionPoints[i];
          if (i > 0) {
            result += `<div class="${classNames.tablePadding}"></div>`;
          }
          result += `<table class="${classNames.table}">
            <tr><td colspan="2" class="${classNames.cellPaddingBottom} ${classNames.title}">${intersectionPoint.tooltip.title}</td></tr>
            <tr><td class="${classNames.cellPaddingBottom}">${intersectionPoint.tooltip.description}</td>
              <td class="${classNames.numeric}">${intersectionPoint.tooltip.price}</td></tr>
            <tr><td colspan="2" class="${classNames.divider}"></td></tr>
            <tr><td class="${classNames.cellPaddingBottom} ${classNames.cellPaddingTop}">% of responses</td><td class="${classNames.numeric}">${intersectionPoint.tooltip.percentage}</td></tr>
            <tr><td>Responses</td><td class="${classNames.numeric}">${intersectionPoint.tooltip.response}</td></tr>
            </table>`;
        }
        return result || false;
      }
    },
    yAxis: {
      min: 0,
      max: 100,
      title: {
        style: {
          color: '#404040',
          fontFamily: 'National 2',
          fontWeight: '600',
          fontSize: '12px'
        },
        text: 'Percent'
      },
      labels: {
        format: `{value}%`
      }
    },
    xAxis: {
      // tickInterval: 1, This used display more ticks
      labels: {
        formatter() {
          return `$${this.value}`;
        }
      },
      plotLines: [{
        color: '#000000',
        value: xBoundaries.upperBound,
        dashStyle: 'LongDash',
        width: 1
      }, {
        color: '#000000',
        value: xBoundaries.lowerBound,
        dashStyle: 'LongDash',
        width: 1
      }]
    }
  }, options,
  // not overridable
  {
    series,
    credits: {
      enabled: false
    }
  });
};
function VanWestendorpChart({
  data,
  options
}) {
  const classNames = useStyles$5();
  const {
    upperBound,
    lowerBound
  } = data.metadata;
  const {
    pointsOfInterest,
    acceptableRange
  } = getHighchartSeriesData(data);
  const series = getHighchartSeries(data, pointsOfInterest, acceptableRange);
  const xBoundaries = {
    upperBound: upperBound.price,
    lowerBound: lowerBound.price
  };
  const dataTableValues = map(pointsOfInterest, 'tooltip') || [];
  const vanWestendorpChartOptions = getVanWestendorpChartOptions(series, xBoundaries, pointsOfInterest, options, classNames);
  return React__default.createElement(Box, null, React__default.createElement(HighchartsReact, {
    highcharts: Highcharts,
    options: vanWestendorpChartOptions
  }), React__default.createElement(VanWestendorpChartDataTable, {
    data: dataTableValues
  }));
}

/* eslint-disable react/no-array-index-key */
function SpacerSquares({
  range,
  width,
  height,
  offset,
  spacing
}) {
  return React__default.createElement(React__default.Fragment, null, range.map((r, i) => React__default.createElement(React__default.Fragment, {
    key: `spacer-rect-${i}`
  }, React__default.createElement("rect", {
    fill: "white",
    height: height,
    width: spacing * 2,
    x: i * offset + width,
    y: 0,
    style: {
      zIndex: 999
    }
  }))));
}
function RatingBarProgress({
  rating,
  fill,
  width,
  height,
  maxRating,
  spacing = 0
}) {
  const animationRef = useRef();
  const prevRating = useRef(0);
  useSSRSafeLayoutEffect(() => {
    prevRating.current = rating;
    const animation = animationRef === null || animationRef === void 0 ? void 0 : animationRef.current;
    if (animation && animation.beginElement) {
      animation.beginElement();
    }
  }, [rating]);
  // Adjust for spacer-gaps; progress does not take this in to account normally.
  const spacerPercent = spacing * 2 / 100;
  return React__default.createElement("rect", {
    fill: fill,
    height: height - 0.2,
    width: width,
    x: 0,
    y: 0.1
  }, React__default.createElement("animate", {
    ref: r => {
      animationRef.current = r;
    },
    attributeName: "width",
    from: `${(prevRating.current / maxRating - spacerPercent) * 100}%`,
    to: `${(rating / maxRating - spacerPercent) * 100}%`,
    dur: "1s",
    fill: "freeze"
  }));
}

/* eslint-disable react/no-array-index-key */
function RatingIcons({
  range,
  width,
  offset,
  iconComponent: Icon
}) {
  return React__default.createElement(React__default.Fragment, null, range.map((r, i) => React__default.createElement(React__default.Fragment, {
    key: `icon-rect-${i}`
  }, React__default.createElement("g", null, React__default.createElement(Icon, {
    x: i * offset + width / 4,
    width: width / 2,
    title: "",
    color: "light"
  })))));
}

/* eslint-disable react/no-array-index-key */
function EmptySquares({
  range,
  fill,
  width,
  height,
  offset
}) {
  return React__default.createElement(React__default.Fragment, null, range.map((r, i) => React__default.createElement("rect", {
    key: `empty-rect-${i}`,
    fill: fill,
    height: height,
    width: width,
    x: i * offset,
    y: 0
  })));
}

// svg size parameter to ensure scaling
const baseSize = 10;
// spacing between block elements
const spacing = 0.5;
// offset calculation for spacing between elements
const xOffset = Math.ceil((baseSize * 2 + spacing) / 2);
function RatingBar({
  maxRating = 5,
  rating,
  fillColor,
  emptyColor = '#D0D2D3',
  iconComponent
}) {
  if (!Number.isFinite(rating)) {
    return null;
  }
  // dynamic box size calculation for svg scaling
  const boxSizeX = Math.ceil((baseSize + spacing) * maxRating + spacing * maxRating);
  const range = Array.from(new Array(maxRating));
  return React__default.createElement("svg", {
    viewBox: `0 0 ${boxSizeX} ${baseSize}`,
    preserveAspectRatio: "xMidYMid",
    width: "100%",
    height: "100%"
  }, React__default.createElement(EmptySquares, {
    range: range,
    width: baseSize,
    height: baseSize,
    fill: emptyColor,
    offset: xOffset
  }), React__default.createElement(RatingBarProgress, {
    fill: fillColor,
    height: baseSize,
    width: baseSize,
    rating: rating,
    maxRating: maxRating,
    spacing: spacing
  }), React__default.createElement(SpacerSquares, {
    range: range,
    width: baseSize,
    height: baseSize,
    offset: xOffset,
    spacing: spacing
  }), React__default.createElement(RatingIcons, {
    range: range,
    width: baseSize,
    offset: xOffset,
    iconComponent: iconComponent
  }));
}
const useStyles$4 = createUseStyles(theme => ({
  container: ({
    width = 0,
    height = 0
  }) => ({
    width: width || '100%',
    height: height || '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }),
  scaleContainer: {
    display: 'inline-block',
    transform: ({
      scaleAmount
    }) => `scale(${scaleAmount})`
  },
  content: {
    padding: theme.spacing[3]
  }
}));
const useStyles$3 = createUseStyles(theme => ({
  ratingWrapper: {
    maxWidth: '200px',
    display: 'flex',
    paddingTop: theme.spacing[3]
  }
}));
function RatingWrapper({
  children
}) {
  const {
    ratingWrapper
  } = useStyles$3();
  return React__default.createElement("div", {
    className: ratingWrapper
  }, children);
}

/* eslint-disable default-param-last */
const COPY$3 = defineMessages({
  AVERAGE_RATING: {
    id: 'RatingChart.AVERAGE_RATING',
    defaultMessage: `average rating`,
    description: '[Type: label][Vis: high] - average rating title'
  }
});
function useScale(outer = {}, inner = {}, {
  min = 0,
  max = 10
}) {
  const [scale, setScale] = React__default.useState(1);
  React__default.useMemo(() => {
    if (outer.width && outer.height && inner.width && inner.height) {
      const size = Math.min(outer.height / inner.height, outer.width / inner.width);
      const result = Math.max(min, Math.min(size, max));
      setScale(result);
    }
  }, [inner.height, inner.width, outer.height, outer.width, min, max]);
  return scale;
}
function RatingChart({
  rating,
  fillColor = '#00bf6f',
  maxRating = 5,
  iconComponent = 'STAR',
  width,
  height,
  scale = {
    max: 1.3
  }
}) {
  const [containerRef, outerDimensions] = useDimensions();
  const [contentRef, innerDimensions] = useDimensions();
  const scaleAmount = useScale(outerDimensions, innerDimensions, scale);
  const {
    container,
    scaleContainer,
    content
  } = useStyles$4({
    width,
    height,
    scaleAmount
  });
  const Icon = getWDSIconFromChartIcon(iconComponent);
  if (!Number.isFinite(rating)) {
    return null;
  }
  const normalizedRating = Math.min(Math.max(rating, 0), maxRating);
  return React__default.createElement("div", {
    ref: containerRef,
    className: container
  }, React__default.createElement("div", {
    className: scaleContainer
  }, React__default.createElement("div", {
    ref: contentRef,
    className: content
  }, React__default.createElement(Typography, {
    variant: "hero1",
    align: "center",
    key: "hero-title"
  }, normalizedRating.toFixed(1), React__default.createElement("span", {
    style: {
      color: fillColor
    }
  }, React__default.createElement(Icon, {
    title: "",
    size: "lg"
  }))), React__default.createElement(Typography, {
    variant: "sectionTitle",
    align: "center",
    key: "hero-subtitle"
  }, React__default.createElement(T, {
    desc: COPY$3.AVERAGE_RATING
  })), React__default.createElement(Box, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    key: "rating-bar"
  }, React__default.createElement(RatingWrapper, {
    key: "rating-wrapper"
  }, React__default.createElement(RatingBar, {
    key: "rating-bar",
    maxRating: maxRating,
    rating: normalizedRating,
    fillColor: fillColor,
    iconComponent: Icon
  }))))));
}
defineMessages({
  ANSWERED: {
    id: 'RatingChartLegend.ANSWERED',
    defaultMessage: `Answered: {number}`,
    description: '[Type: label][Vis: high] - amount of responses answered'
  },
  SKIPPED: {
    id: 'RatingChartLegend.SKIPPED',
    defaultMessage: `Skipped: {skipped}`,
    description: '[Type: label][Vis: high] - amount of responses skippeed'
  },
  TOOLTIP: {
    id: 'RatingChartLegend.TOOLTIP',
    defaultMessage: `{label} ({percent, number, percent})`,
    description: '[Type: label][Vis: high] - percentage tooltip'
  },
  RATING: {
    id: 'RatingChartLegend.RATING',
    defaultMessage: `{rating} star`,
    description: '[Type: label][Vis: high] - rating amount'
  }
});
// Fixes 'Rating Star Labels' (i.e. 1 Star, 5 Star, etc) wrapping on two lines when viewport is
// smaller than 430px.
// 2.666666666666667em = 40px
// Resolves: #ANEXP-1338, #RAWR-559
createUseStyles({
  ratingLabelColumnStyles: {
    minWidth: '2.666666666666667em'
  },
  ratingProgressLine: {
    maxWidth: '100%'
  }
});
const COPY$2 = defineMessages({
  UTILITY_SCORE_TOOLTIP: {
    id: 'MaxDiffChart.UTILITY_SCORE_TOOLTIP',
    defaultMessage: 'Utility score',
    description: '[Type: Label][Vis: low] - Utility score label for chart tooltip'
  },
  CONFIDENCE_INTERVAL_TOOLTIP: {
    id: 'MaxDiffChart.CONFIDENCE_INTERVAL_TOOLTIP',
    defaultMessage: 'Confidence interval',
    description: '[Type: Label][Vis: low] - Confidence interval label for chart tooltip'
  }
});
if (typeof Highcharts === 'object') {
  HighchartsMore(Highcharts);
}
const getMaxDiffChartOptions = (data, options, confidenceInterval, isPercentage = false, decimalPlaces = 0) => {
  let enableTooltip = false;
  let disableDataLabel = true;
  if (confidenceInterval && confidenceInterval.length !== 0) {
    enableTooltip = true;
    disableDataLabel = false;
  }
  return merge(
  // overwritable defaults
  {
    plotOptions: {
      bar: {
        enableMouseTracking: true,
        states: {
          hover: {
            enabled: enableTooltip
          }
        },
        colorByPoint: true,
        dataLabels: {
          enabled: disableDataLabel,
          format: `{y:.${decimalPlaces}f}${isPercentage ? '%' : ''}`,
          inside: false
        }
      },
      errorbar: {
        dataLabels: {
          enabled: false
        }
      }
    },
    tooltip: {
      enabled: enableTooltip,
      shared: true,
      followPointer: false,
      followTouchMove: true,
      backgroundColor: '#404040',
      useHTML: true,
      formatter() {
        if (this && this.points && 'points' in this && confidenceInterval) {
          return `<table style="color: #FFFFFF; text-align: center"><tr><th colspan="2">${this.x}</th></tr><tr><td>${t(COPY$2.UTILITY_SCORE_TOOLTIP)}: ${this.y.toFixed(2)}</td></tr><tr><td>${t(COPY$2.CONFIDENCE_INTERVAL_TOOLTIP)}: (${confidenceInterval[this.points[0].point.index][0].toFixed(2)}, ${confidenceInterval[this.points[0].point.index][1].toFixed(2)})</td></tr></table>`;
        }
        return undefined;
      }
    },
    xAxis: {
      labels: {
        formatter: formatLabelVerticalAxis
      }
    },
    yAxis: {
      labels: {
        format: `{value}${isPercentage ? '%' : ''}`
      }
    }
  }, options,
  // not overwritable
  {
    series: [{
      data,
      type: 'bar'
    }, {
      data: confidenceInterval,
      type: 'errorbar'
    }]
  });
};
function MaxDiffChart({
  data,
  options,
  confidenceInterval,
  isPercentage,
  decimalPlaces
}) {
  const maxDiffChartOptions = getMaxDiffChartOptions(data, options, confidenceInterval, isPercentage, decimalPlaces);
  return React__default.createElement(BaseChart, {
    options: maxDiffChartOptions
  });
}
function getPieDataLabelFormatted(point, showInLegend, isDataInChart, decimalPlaces) {
  const {
    name,
    y,
    numberOfResponses
  } = point;
  if (!y) {
    // eslint-disable-next-line no-console
    console.error('"y" property for data point is undefined. The label cannot be formatted.');
    return '';
  }
  const nameLabel = name.length > 68 ? `${name.substring(0, 65)}...` : name;
  const dataLabel = isDataInChart ? `<br> ${numberFormat(y, decimalPlaces)}% (${numberOfResponses})` : '';
  return showInLegend ? dataLabel : nameLabel + dataLabel;
}
const getPieDonutChartMapping = (customization, data) => {
  const isDataInChart = customization.dataInChart;
  const showInLegend = customization.dataFormatLabel === 'Legend';
  const options = {
    colors: [...customization.colors],
    plotOptions: {
      pie: {
        cursor: 'default',
        showInLegend,
        dataLabels: {
          style: {
            width: 108 // width used in prod
          },

          enabled: showInLegend && isDataInChart || !showInLegend,
          formatter() {
            return getPieDataLabelFormatted(this.point, showInLegend, isDataInChart, customization.decimalPlaces);
          }
        }
      }
    },
    tooltip: {
      enabled: false
    },
    legend: {
      enabled: showInLegend,
      labelFormatter() {
        return this.name.length > 93 ? `${this.name.substring(0, 90)}...` : this.name;
      }
    }
  };
  return {
    options,
    data
  };
};

/**
 * Map the base options configuration for
 * bar, column, stacked bar and stacked column charts.
 * This data may be augmented at the Chart level.
 */
const getCommonBarChartMapping = customization => {
  const {
    labels,
    colors,
    min,
    max,
    dataInChart
  } = customization;
  const showTooltip = !dataInChart;
  return {
    colors,
    yAxis: {
      min,
      max,
      startOnTick: typeof min !== 'number',
      endOnTick: typeof max !== 'number'
    },
    xAxis: {
      categories: labels
    },
    tooltip: {
      enabled: showTooltip
    }
  };
};
const getBarChartMapping = (customization, data) => {
  const isPercentage = customization.axisScale === 'Percentage';
  const isDataMultiDimension = isTwoDimensionalChartData(data);
  const commonBarChartOptions = getCommonBarChartMapping(customization);
  const options = merge(commonBarChartOptions, {
    legend: {
      enabled: isDataMultiDimension
    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: customization.dataInChart
        },
        colorByPoint: !isDataMultiDimension
      }
    }
  });
  return {
    data,
    options,
    isPercentage,
    decimalPlaces: customization.decimalPlaces
  };
};
const getColumnChartMapping = (customization, data) => {
  const isPercentage = customization.axisScale === 'Percentage';
  const isDataMultiDimension = isTwoDimensionalChartData(data);
  const commonBarChartOptions = getCommonBarChartMapping(customization);
  const options = merge(commonBarChartOptions, {
    legend: {
      enabled: isDataMultiDimension
    },
    plotOptions: {
      column: {
        dataLabels: {
          enabled: customization.dataInChart
        },
        colorByPoint: !isDataMultiDimension
      }
    }
  });
  return {
    data,
    options,
    isPercentage,
    decimalPlaces: customization.decimalPlaces
  };
};
const getStackedBarChartMapping = (customization, data) => {
  const isPercentage = customization.axisScale === 'Percentage';
  const commonBarChartOptions = getCommonBarChartMapping(customization);
  const showLabels = data[0].data.length > 1;
  const options = merge(commonBarChartOptions, {
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: customization.dataInChart
        },
        colorByPoint: false
      }
    }
  });
  return {
    data,
    options,
    isPercentage,
    showLabels,
    decimalPlaces: customization.decimalPlaces
  };
};
const getStackedColumnChartMapping = (customization, data) => {
  const isPercentage = customization.axisScale === 'Percentage';
  const commonBarChartOptions = getCommonBarChartMapping(customization);
  const showLabels = data[0].data.length > 1;
  const options = merge(commonBarChartOptions, {
    plotOptions: {
      column: {
        dataLabels: {
          enabled: customization.dataInChart
        },
        colorByPoint: false
      }
    }
  });
  return {
    data,
    options,
    isPercentage,
    showLabels,
    decimalPlaces: customization.decimalPlaces
  };
};
const getLineAreaChartMapping = (customization, data) => {
  const {
    colors,
    labels,
    max,
    min
  } = customization;
  const isTwoDimensionalLineAreaData = chartData => chartData[0].name !== '';
  return {
    colors,
    xAxis: {
      categories: labels
    },
    yAxis: {
      min,
      max,
      startOnTick: typeof min !== 'number',
      endOnTick: typeof max !== 'number'
    },
    legend: {
      enabled: isTwoDimensionalLineAreaData(data)
    }
  };
};
const getLineChartMapping = (customization, data) => {
  const isPercentage = customization.axisScale === 'Percentage';
  const commonLineChartOptions = getLineAreaChartMapping(customization, data);
  const options = merge(commonLineChartOptions, {
    plotOptions: {
      line: {
        dataLabels: {
          enabled: customization.dataInChart
        }
      }
    }
  });
  return {
    data,
    options,
    isPercentage,
    decimalPlaces: customization.decimalPlaces
  };
};
const getAreaChartMapping = (customization, data) => {
  const isPercentage = customization.axisScale === 'Percentage';
  const isStackable = data.length > 1;
  const commonLineChartOptions = getLineAreaChartMapping(customization, data);
  const options = merge(commonLineChartOptions, {
    plotOptions: {
      area: {
        dataLabels: {
          enabled: customization.dataInChart
        }
      }
    }
  });
  return {
    data,
    options,
    isPercentage,
    isStackable,
    decimalPlaces: customization.decimalPlaces
  };
};
function getRatingChartMapping(customization, data) {
  var _customization$colors;
  return {
    rating: data.value,
    fillColor: (_customization$colors = customization.colors) !== null && _customization$colors !== void 0 && _customization$colors.length ? customization.colors[0] : undefined,
    maxRating: customization.max,
    iconComponent: customization.iconComponent ?? undefined
  };
}
const getVanWestendorpChartMapping = (customization, data) => {
  const options = {
    plotOptions: {
      line: {
        dataLabels: {
          enabled: customization.dataInChart
        }
      }
    }
  };
  return {
    data,
    options
  };
};
function AggregateResponseChartSelector({
  data,
  customization
}) {
  switch (customization.chartType) {
    case 'hbar':
      {
        assert(isBarChartData(data));
        return React__default.createElement(BarChart, {
          ...getBarChartMapping(customization, data)
        });
      }
    case 'vbar':
      {
        assert(isBarChartData(data));
        return React__default.createElement(ColumnChart, {
          ...getColumnChartMapping(customization, data)
        });
      }
    case 'donut':
      {
        assert(isPieOrDonutChartData(data));
        return React__default.createElement(DonutChart, {
          ...getPieDonutChartMapping(customization, data)
        });
      }
    case 'pie':
      {
        assert(isPieOrDonutChartData(data));
        return React__default.createElement(PieChart, {
          ...getPieDonutChartMapping(customization, data)
        });
      }
    case 'stacked_hbar':
      {
        assert(isStackedBarChartData(data));
        return React__default.createElement(StackedBarChart, {
          ...getStackedBarChartMapping(customization, data)
        });
      }
    case 'stacked_vbar':
      {
        assert(isStackedBarChartData(data));
        return React__default.createElement(StackedColumnChart, {
          ...getStackedColumnChartMapping(customization, data)
        });
      }
    case 'line':
      {
        assert(isLineChartData(data));
        return React__default.createElement(LineChart, {
          ...getLineChartMapping(customization, data)
        });
      }
    case 'area':
      {
        assert(isAreaChartData(data));
        return React__default.createElement(AreaChart, {
          ...getAreaChartMapping(customization, data)
        });
      }
    case 'weighted_avg':
      {
        assert(isRatingChartData(data));
        return React__default.createElement(RatingChart, {
          ...getRatingChartMapping(customization, data)
        });
      }
    case 'van_westendorp':
      {
        assert(isVanWestendorpChartData(data));
        return React__default.createElement(VanWestendorpChart, {
          ...getVanWestendorpChartMapping(customization, data)
        });
      }
    case 'maxdiff':
      {
        assert(isBarChartData(data));
        return React__default.createElement(MaxDiffChart, {
          ...getBarChartMapping(customization, data)
        });
      }
    default:
      {
        return null;
      }
  }
}
const useStyles$2 = createUseStyles(theme => {
  return {
    container: {
      width: '100%',
      background: '#EFEFEF',
      padding: theme.spacing[5],
      marginBottom: theme.spacing[2]
    },
    pagination: {
      borderTop: '1px solid rgb(237 238 238)',
      padding: `${theme.spacing[5]}px 0px`
    },
    header: {
      paddingLeft: theme.spacing[2]
    }
  };
});
const COPY$1 = defineMessages({
  OTHER_RESPONSES_HEADER: {
    id: 'OtherResponseList.OTHER_RESPONSES_HEADER',
    defaultMessage: `"{title}" responses ({totalCount})`,
    description: '[Type: Label][Vis: med] - Header for other responses'
  },
  OTHER_RESPONSES_HEADER_CARET_DOWN: {
    id: 'OtherResponseList.OTHER_RESPONSES_HEADER_CARET_DOWN',
    defaultMessage: 'hide other response list',
    description: '[Type: Button][Vis: med] - Icon shown to hide other response list'
  },
  OTHER_RESPONSES_HEADER_CARET_UP: {
    id: 'OtherResponseList.OTHER_RESPONSES_HEADER_CARET_UP',
    defaultMessage: 'show other response list',
    description: '[Type: Button][Vis: med] - Icon shown to show other response list'
  }
});
function OtherResponseList(data) {
  const {
    container,
    header,
    pagination
  } = useStyles$2();
  const [isOpen, setIsOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [dataItems, setDataItems] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const otherResponseListRef = useRef(null);
  useEffect(() => {
    const firstRowOnPage = page * rowsPerPage;
    const lastRowOnPage = page * rowsPerPage + rowsPerPage;
    const showItems = data && data.items && Object.values(data.items).slice(firstRowOnPage, lastRowOnPage) || [];
    setDataItems(showItems);
  }, [page, rowsPerPage, data]);
  const handleChangePage = (event, newPage) => {
    var _otherResponseListRef;
    (_otherResponseListRef = otherResponseListRef.current) === null || _otherResponseListRef === void 0 ? void 0 : _otherResponseListRef.scrollIntoView(true);
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    var _otherResponseListRef2;
    (_otherResponseListRef2 = otherResponseListRef.current) === null || _otherResponseListRef2 === void 0 ? void 0 : _otherResponseListRef2.scrollIntoView(true);
    setRowsPerPage(parseInt(event.currentTarget.dataset.value || '10', 10));
    setPage(0);
  };
  const toggleList = () => {
    setIsOpen(prevState => !prevState);
  };
  return React__default.createElement("div", {
    ref: otherResponseListRef
  }, React__default.createElement("div", {
    className: container,
    onClick: toggleList,
    onKeyPress: toggleList,
    role: "button",
    tabIndex: 0
  }, isOpen ? React__default.createElement(IconCaretUp, {
    title: t(COPY$1.OTHER_RESPONSES_HEADER_CARET_UP),
    size: "sm"
  }) : React__default.createElement(IconCaretDown, {
    title: t(COPY$1.OTHER_RESPONSES_HEADER_CARET_DOWN),
    size: "sm"
  }), React__default.createElement("span", {
    className: header
  }, React__default.createElement(Typography, {
    variant: "body",
    component: "span"
  }, t(COPY$1.OTHER_RESPONSES_HEADER, {
    title: data.title,
    totalCount: data.totalCount
  })))), isOpen && React__default.createElement(React__default.Fragment, null, React__default.createElement(Table$1, null, React__default.createElement(Table$1.Body, null, dataItems.map((item, index) => {
    return (
      // There is no unique key from backend at the moment. Please update once it is received
      // eslint-disable-next-line react/no-array-index-key
      React__default.createElement(Table$1.Row, {
        key: `table-row-${item.text}-${index}`
      }, React__default.createElement(Table$1.Cell, null, React__default.createElement(Typography, {
        variant: "bodySm",
        color: "dark"
      }, item.text)))
    );
  }))), React__default.createElement("div", {
    className: pagination
  }, React__default.createElement(Pagination, {
    placement: "top-left",
    hasPageSelect: true,
    hasRowsPerPage: true,
    page: page,
    count: data.totalCount,
    rowsPerPage: rowsPerPage,
    onChangePage: handleChangePage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  }))));
}
const useStyles$1 = createUseStyles(theme => ({
  /** for some reason, @wds/box doesn't play nice */
  box: {
    width: '100%',
    height: '100%',
    padding: [0, theme.spacing[3]]
  }
}));
function SolutionsChartDashboardItem({
  data,
  customization,
  otherAnswers,
  ...props
}) {
  const {
    box
  } = useStyles$1();
  const hasData = isChartData(data);
  return React__default.createElement(SolutionsCardLayoutTemplate, {
    ...props
  }, React__default.createElement("div", {
    className: box
  }, hasData ? React__default.createElement(React__default.Fragment, null, React__default.createElement(AggregateResponseChartSelector, {
    ...{
      data,
      customization
    }
  }), otherAnswers && otherAnswers.items && otherAnswers.items.length > 0 && React__default.createElement(OtherResponseList, {
    ...otherAnswers
  })) : React__default.createElement(ResponseError, null)));
}
var SolutionsChartDashboardItem$1 = withErrorBoundary(SolutionsChartDashboardItem);
const COPY = defineMessages({
  SOLUTIONS_PRICE_SENSITIVITY_ITEM_HEADER: {
    id: 'SolutionsPriceSensitivityItem.SOLUTIONS_PRICE_SENSITIVITY_ITEM_HEADER',
    defaultMessage: 'Price sensitivity (Van Westendorp)',
    description: '[Type: Label][Vis: med] - Header for Solutions Price Sensitivity Item'
  },
  SOLUTIONS_PRICE_SENSITIVITY_ITEM_CAPTION: {
    id: 'SolutionsPriceSensitivityItem.SOLUTIONS_PRICE_SENSITIVITY_CAPTION',
    defaultMessage: 'The intersection between inexpensive and expensive gives an overall price direction for your product.',
    description: '[Type: Label][Vis: med] - Caption for Solutions Price Sensitivity Item'
  }
});
function SolutionsPriceSensitivityItem({
  data,
  customization
}) {
  const hasData = isVanWestendorpChartData(data);
  return React__default.createElement(SolutionsCard, null, React__default.createElement(Box, {
    p: 6
  }, React__default.createElement(Box, {
    mb: 1
  }, React__default.createElement(Typography, {
    variant: "cardTitle",
    color: "dark",
    translate: "no",
    component: "strong"
  }, t(COPY.SOLUTIONS_PRICE_SENSITIVITY_ITEM_HEADER))), React__default.createElement(Box, {
    mb: 2
  }, React__default.createElement(Typography, {
    variant: "caption"
  }, t(COPY.SOLUTIONS_PRICE_SENSITIVITY_ITEM_CAPTION))), hasData ? React__default.createElement(AggregateResponseChartSelector, {
    ...{
      data,
      customization
    }
  }) : React__default.createElement(ResponseError, null)));
}
var SolutionsPriceSensitivityItem$1 = withErrorBoundary(SolutionsPriceSensitivityItem);

/**
 * Fix the values after decimal
 */
const formatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2
});
const useStyles = createUseStyles({
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    height: '100%',
    width: '100%'
  }
});
function KeyFindingDataTable({
  data
}) {
  const {
    container
  } = useStyles();
  return React__default.createElement("div", {
    className: container
  }, React__default.createElement(Table$1, {
    xScroll: true
  }, React__default.createElement(Table$1.Header, null, React__default.createElement(Table$1.Row, null, Object.keys(data).map(heading => {
    return React__default.createElement(Table$1.HeaderCell, {
      key: heading
    }, upperFirst(lowerCase(heading)));
  }))), React__default.createElement(Table$1.Body, null, React__default.createElement(Table$1.Row, null, Object.values(data).map(columnData => {
    return React__default.createElement(Table$1.Cell, {
      key: columnData
    }, formatter.format(columnData));
  })))));
}

/**
 * Component to create Statistics table
 */
function SolutionStatistics({
  ...props
}) {
  return React__default.createElement(SolutionsCardLayoutTemplate, {
    ...props
  }, React__default.createElement(KeyFindingDataTable, {
    data: props.data
  }));
}
var SolutionStatistics$1 = withErrorBoundary(SolutionStatistics);
export { SolutionsOpenEndedItem$1 as CommentBox, defaultChartColors as DEFAULT_COLORS, SolutionsChartDashboardItem$1 as Dropdown, SolutionsChartDashboardItem$1 as Matrix, SolutionsChartDashboardItem$1 as MultipleChoice, SolutionsPriceSensitivityItem$1 as PriceSensitivity, SolutionsChartDashboardItem$1 as Ranking, SolutionsOpenEndedItem$1 as SingleTextbox, SolutionStatistics$1 as SolutionStatistics, SolutionsChartDashboardItem$1 as SolutionsChartDashboardItem, SolutionsOpenEndedItem$1 as SolutionsOpenEndedItem };